
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kzwZ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cd7ca16b53ec49f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $FoFt2 = parcelRequire("FoFt2");

var $75Qwl = parcelRequire("75Qwl");

var $8wC3Q = parcelRequire("8wC3Q");
function $cd7ca16b53ec49f3$export$2e2bcd8739ae039(props) {
    if ((0, $FoFt2.isIntersectionObserverSupported)()) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $75Qwl.LazyIntersectionObserverCard), {
        ...props
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wC3Q.LazyLazilyRenderCard), {
        ...props
    });
}

});
parcelRegister("75Qwl", function(module, exports) {

$parcel$export(module.exports, "LazyIntersectionObserverCard", () => $ff4bc0d2b4ef26a4$export$f7e6e9ba10fbcbe9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fwyi5 = parcelRequire("fwyi5");

var $1mLfK = parcelRequire("1mLfK");

var $4HS95 = parcelRequire("4HS95");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
// This property enables the intersection observer to be run once the
// HTML element being observed is within `X` px of the target container it is
// being compared to. Since the default container is the `document`, we set this
// up to check once a Smart Link is within `X` px from the bottom of the viewport.
const $ff4bc0d2b4ef26a4$var$ROOT_MARGIN_VERTICAL = '360px';
function $ff4bc0d2b4ef26a4$export$f7e6e9ba10fbcbe9(props) {
    const ref = (0, $eJOHy.useRef)(null);
    const [isIntersecting, setIsIntersecting] = (0, $eJOHy.useState)(false);
    const [shouldSendRenderedUFOEvent] = (0, $eJOHy.useState)((0, $4HS95.shouldSample)());
    const { appearance: appearance, url: url, id: id } = props;
    const prefetch = (0, $fwyi5.usePrefetch)(url);
    const Component = appearance === 'inline' ? 'span' : 'div';
    const ComponentObserver = Component;
    const onIntersection = (0, $eJOHy.useCallback)((entries, observer)=>{
        const isVisible = entries.some((entry)=>entry.isIntersecting);
        if (isVisible) {
            if (shouldSendRenderedUFOEvent) (0, $1mLfK.startUfoExperience)('smart-link-rendered', id);
            setIsIntersecting(true);
            observer.disconnect();
        } else prefetch();
    }, [
        id,
        prefetch,
        shouldSendRenderedUFOEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref.current) return;
        const intersectionObserver = new IntersectionObserver(onIntersection, {
            rootMargin: `${$ff4bc0d2b4ef26a4$var$ROOT_MARGIN_VERTICAL} 0px ${$ff4bc0d2b4ef26a4$var$ROOT_MARGIN_VERTICAL} 0px`
        });
        intersectionObserver.observe(ref.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        ref,
        onIntersection
    ]);
    const content = isIntersecting ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentObserver, {
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...props
        })
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        className: "loader-wrapper",
        children: content
    });
}

});
parcelRegister("fwyi5", function(module, exports) {

$parcel$export(module.exports, "usePrefetch", () => $9f1b013bc96bc791$export$4dcd17e50290e364);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");
function $9f1b013bc96bc791$export$4dcd17e50290e364(url) {
    const { store: store, prefetchStore: prefetchStore, connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const { dispatch: dispatch, getState: getState } = store || {};
    const { client: client } = connections || {};
    return (0, $eJOHy.useCallback)(async ()=>{
        // If smartlink context props are undefined do nothing.
        if (!store || !prefetchStore || !connections) return;
        // If the link is already being prefetched, the prefetch store
        // should have a flag set against the URL. The prefetch store is purposefully
        // separate from the UI in order to ensure no rendering takes place;
        // all mutations which occur are purely store-based mutations.
        const isPrefetching = prefetchStore[url];
        // If the link has already been registered in the store, then it no
        // longer needs to be prefetched, as the normal flow of a link being in
        // the viewport and being fetched is now in motion.
        const isFetching = getState()[url];
        // We compute if a link needs to be prefetched thus, referencing the above.
        const needsPrefetch = !isPrefetching && !isFetching;
        if (needsPrefetch) {
            // We specify in the prefetch store that this link no
            // longer needs to be prefetched. Data which comes back
            // from a successful prefetch flow here will be used to
            // render all URLs which are the same.
            prefetchStore[url] = true;
            // Try fetch the data for this URL from Object Resolver Service (ORS), executing batch
            // requests by domain (as usual) to ensure we minimize the amount of connections
            // we create between browser -> ORS when making network requests.
            try {
                const response = await client.prefetchData(url);
                // Once the data comes back, we put the link in the `resolved` status. This ensures
                // that when the link enters the viewport and is rendered, we immediately show it as
                // a Smart Link, rather than rendering a loading spinner -> immediate Smart Link.
                if (response) {
                    dispatch({
                        type: 'resolved',
                        url: url,
                        payload: response
                    });
                    // Put the metadata in resolved state, theres no need for a pending or errored state as
                    // we are following the same render flow as described by the comments above and below.
                    dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
                        url: url
                    }, undefined, undefined, 'resolved'));
                }
            } catch (_err) {
            // Do nothing, link will be retried under the hood with exponential backoff.
            // If it does not succeed even after those retries, the normal resolve flow
            // will start when the link is in view. Since we have not performed any store
            // mutations yet, the link will behave like a 'brand new' link.
            }
        }
    }, [
        store,
        prefetchStore,
        connections,
        url,
        getState,
        client,
        dispatch
    ]);
}

});

parcelRegister("4HS95", function(module, exports) {

$parcel$export(module.exports, "shouldSample", () => $dea9a9f3b65bc010$export$a86202d561cb4183);
const $dea9a9f3b65bc010$export$a86202d561cb4183 = (threshold = 0.5)=>Math.random() > threshold;

});

parcelRegister("4oATR", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $e563c8affb3daadf$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $iT7eO = parcelRequire("iT7eO");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $fezTc = parcelRequire("fezTc");

var $FoFt2 = parcelRequire("FoFt2");

var $88ISi = parcelRequire("88ISi");

var $liquj = parcelRequire("liquj");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $3u14o = parcelRequire("3u14o");

var $9uyEx = parcelRequire("9uyEx");

var $19G04 = parcelRequire("19G04");

var $6J1DL = parcelRequire("6J1DL");
const $e563c8affb3daadf$var$thirdPartyARIPrefix = 'ari:third-party';
function $e563c8affb3daadf$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    const thirdPartyARI = (0, $03JM4.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $03JM4.getFirstPartyIdentifier)();
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
            if (thirdPartyARI && thirdPartyARI.startsWith($e563c8affb3daadf$var$thirdPartyARIPrefix)) {
                const clickURL = (0, $03JM4.getClickUrl)(url, state.details);
                if (clickURL === url) {
                    // For questions or concerns about this event,
                    // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
                    const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'smartLink',
                        actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
                        eventType: 'ui',
                        attributes: {
                            eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                            firstPartyIdentifier: firstPartyIdentifier
                        },
                        nonPrivacySafeAttributes: {
                            thirdPartyARI: thirdPartyARI
                        }
                    });
                    smartlinkClickAnalyticsEvent.fire('media');
                }
            }
        }
        const isDisablePreviewPanel = disablePreviewPanel && (0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !isDisablePreviewPanel) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details)
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        thirdPartyARI,
        firstPartyIdentifier,
        disablePreviewPanel
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9uyEx.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $e563c8affb3daadf$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $1YI3f.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5NtHI.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("92xoS", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $19fb77b8a89e4410$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $19fb77b8a89e4410$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $59rsN = parcelRequire("59rsN");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $19fb77b8a89e4410$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $dpRNR.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $19fb77b8a89e4410$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $bfW07._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});

parcelRegister("iT7eO", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $509c107b2b076848$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bde0S = parcelRequire("bde0S");

var $2vJUc = parcelRequire("2vJUc");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");
function $509c107b2b076848$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $5TXKo.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const actions = (0, $bde0S.useSmartCardActions)(id, url);
    const config = (0, $2vJUc.useSmartLinkConfig)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("bde0S", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $0b92ec45d8e4fb8b$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");

var $ldBiz = parcelRequire("ldBiz");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");
const $0b92ec45d8e4fb8b$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $kbv8x.default)();
    const invokeClientAction = (0, $7xssH.default)({});
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5NtHI.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        if (definitionId) (0, $03JM4.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        const extensionKey = (0, $03JM4.getExtensionKey)(details);
        const services = (0, $03JM4.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $ldBiz.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("ldBiz", function(module, exports) {

$parcel$export(module.exports, "auth", () => $3affdc949abfd5e9$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("kwM7Y")).AuthError);

var $kwM7Y = parcelRequire("kwM7Y");

var $jGjox = parcelRequire("jGjox");
function $3affdc949abfd5e9$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jGjox.isOfTypeAuthError)(errorType)) reject(new (0, $kwM7Y.AuthError)(data.message, errorType));
                    else reject(new (0, $kwM7Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $kwM7Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("kwM7Y", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $4f8710bc730ecae5$export$145273558d58e0ac);
class $4f8710bc730ecae5$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jGjox", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $b4e26c6b0cd1efbb$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $b4e26c6b0cd1efbb$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("03JM4", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $a9130c46b8c7e440$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a9130c46b8c7e440$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a9130c46b8c7e440$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a9130c46b8c7e440$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a9130c46b8c7e440$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $a9130c46b8c7e440$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $a9130c46b8c7e440$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $a9130c46b8c7e440$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a9130c46b8c7e440$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a9130c46b8c7e440$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a9130c46b8c7e440$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a9130c46b8c7e440$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a9130c46b8c7e440$export$3f9446bb21b945a0);

var $eGOwo = parcelRequire("eGOwo");

var $70skx = parcelRequire("70skx");
const $a9130c46b8c7e440$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a9130c46b8c7e440$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $70skx.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a9130c46b8c7e440$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a9130c46b8c7e440$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a9130c46b8c7e440$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a9130c46b8c7e440$export$e029950864672b4 = (details)=>{
    if ((0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $eGOwo.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $a9130c46b8c7e440$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $a9130c46b8c7e440$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $a9130c46b8c7e440$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $a9130c46b8c7e440$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a9130c46b8c7e440$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a9130c46b8c7e440$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a9130c46b8c7e440$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a9130c46b8c7e440$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a9130c46b8c7e440$export$ac5d414b1ebfab5a = (details)=>details && $a9130c46b8c7e440$export$cd41ae544cfc2a65(details) && $a9130c46b8c7e440$export$795910f5f15a9633(details);
const $a9130c46b8c7e440$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a9130c46b8c7e440$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a9130c46b8c7e440$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a9130c46b8c7e440$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a9130c46b8c7e440$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a9130c46b8c7e440$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a9130c46b8c7e440$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a9130c46b8c7e440$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $a9130c46b8c7e440$var$extractPageIdFromURL = (url)=>{
    try {
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = url.match(/(?!pages)(\d+)/);
        if (pagesMatch && pagesMatch[0]) return pagesMatch[0];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = url.match(/(?!pageId=)(\d+)/);
        if (pageIdParam && pageIdParam[0]) return pageIdParam[0];
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = url.match(/(?!display\/)(\d+)/);
        if (displayMatch && displayMatch[0]) return displayMatch[0];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractContentIdFromURL = (url)=>{
    try {
        const contentId = url.match(/content\.id=(\d+)/);
        if (contentId && contentId[1]) // contentId[1] contains just the number
        return contentId[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const browseMatch = url.match(/[A-Z0-9]+-\d+/);
        if (browseMatch && browseMatch[0]) return browseMatch[0];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a9130c46b8c7e440$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("70skx", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $23c7211e82610c9c$export$c81497d3681f24f4);
const $23c7211e82610c9c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("2vJUc", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $42e17606dc58a0f1$export$5d10838c1e539409);

var $9kfy2 = parcelRequire("9kfy2");
const $42e17606dc58a0f1$export$5d10838c1e539409 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("88ISi", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $8dae431f81ca4538$export$2ae4cf79c720146a);
const $8dae431f81ca4538$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("3u14o", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $5cab8467edf2e496$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $9gzoR = parcelRequire("9gzoR");

var $4UV7R = parcelRequire("4UV7R");

var $dDP8i = parcelRequire("dDP8i");

var $kj3Kk = parcelRequire("kj3Kk");

var $fQuyl = parcelRequire("fQuyl");

var $1uPx2 = parcelRequire("1uPx2");

var $eB1dU = parcelRequire("eB1dU");

var $8jMdw = parcelRequire("8jMdw");

var $4fOPS = parcelRequire("4fOPS");
const $5cab8467edf2e496$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    }) : children;
};
const $5cab8467edf2e496$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $dDP8i.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($5cab8467edf2e496$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uPx2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB1dU.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fQuyl.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9gzoR", function(module, exports) {

$parcel$export(module.exports, "useControlDataExportConfig", () => $99508fe9399992b6$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $99508fe9399992b6$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("4UV7R", function(module, exports) {

$parcel$export(module.exports, "getIsDataExportEnabled", () => $12a2b77c03a84659$export$a019611f39785186);
const $12a2b77c03a84659$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("dDP8i", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $b32501177a2ef5a6$export$9759a67e215c4598);
const $b32501177a2ef5a6$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("fQuyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7e07d7b1d98a1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jkYbX = parcelRequire("jkYbX");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dX77y = parcelRequire("dX77y");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ee7e07d7b1d98a1b$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $dX77y.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $19nmp.messages).could_not_load_link
                }
            })
        ]
    });
};
var $ee7e07d7b1d98a1b$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($ee7e07d7b1d98a1b$var$ErroredView);

});
parcelRegister("dX77y", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $bcb724787f99bc8f$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $bcb724787f99bc8f$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("dXXLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae672cf08406695$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $3pcXQ = parcelRequire("3pcXQ");
var $8Rjtc = parcelRequire("8Rjtc");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");
const $2ae672cf08406695$var$customBlockStyles = null;
const $2ae672cf08406695$var$titleBlockCss = null;
const $2ae672cf08406695$var$footerBlockCss = null;
const $2ae672cf08406695$var$footerBlockSafariStyles = null;
const $2ae672cf08406695$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $g7toL.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $2ae672cf08406695$export$2e2bcd8739ae039 = $2ae672cf08406695$var$UnresolvedView;

});
parcelRegister("19G04", function(module, exports) {

$parcel$export(module.exports, "default", () => $b72b0d53d138fc6a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $k2hJv = parcelRequire("k2hJv");

var $kbv8x = parcelRequire("kbv8x");

var $dpCTw = parcelRequire("dpCTw");

var $025st = parcelRequire("025st");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b72b0d53d138fc6a$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $k2hJv.useAISummaryConfig)();
    const resolve = (0, $kbv8x.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eJOHy.useMemo)(()=>(0, $025st.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5FRJ8.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpCTw.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $b72b0d53d138fc6a$export$2e2bcd8739ae039 = $b72b0d53d138fc6a$var$FlexibleCard;

});
parcelRegister("dpCTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2113f7140aee1e4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hq0iR = parcelRequire("hq0iR");

var $1YI3f = parcelRequire("1YI3f");

var $fqBfo = parcelRequire("fqBfo");

var $hjkWh = parcelRequire("hjkWh");

var $59hpa = parcelRequire("59hpa");
const $2113f7140aee1e4f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $hq0iR.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $1YI3f.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5NtHI.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5NtHI.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $2113f7140aee1e4f$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $1YI3f.isFlexibleUiBlock)(child) ? child : undefined);
};
const $2113f7140aee1e4f$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $fqBfo.default)) return node;
    if ((0, $1YI3f.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $2113f7140aee1e4f$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $2113f7140aee1e4f$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$2113f7140aee1e4f$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $2113f7140aee1e4f$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $2113f7140aee1e4f$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59hpa.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $2113f7140aee1e4f$var$baseStyleCommon = null;
const $2113f7140aee1e4f$var$backgroundStyles = null;
const $2113f7140aee1e4f$var$elevationStyles = null;
const $2113f7140aee1e4f$var$clickableContainerStyles = null;
const $2113f7140aee1e4f$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $2113f7140aee1e4f$var$getPadding = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $2113f7140aee1e4f$var$getGap = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $2113f7140aee1e4f$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $2113f7140aee1e4f$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $2113f7140aee1e4f$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5NtHI.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $hjkWh.default));
    const padding = hidePadding ? '0px' : $2113f7140aee1e4f$var$getPadding(size);
    const gap = $2113f7140aee1e4f$var$getGap(size);
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $2113f7140aee1e4f$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $2113f7140aee1e4f$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $2113f7140aee1e4f$var$previewOnLeftStyleMap[size],
            previewOnRight && $2113f7140aee1e4f$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $2113f7140aee1e4f$var$getLayeredLink(testId, context, children, onClick) : null,
            $2113f7140aee1e4f$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hjkWh.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $2113f7140aee1e4f$export$2e2bcd8739ae039 = $2113f7140aee1e4f$var$Container;

});
parcelRegister("hq0iR", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $0488d9459cc3a179$export$783c1bf8fee63f80);
const $0488d9459cc3a179$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("hjkWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $68910ca9bc088568$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $3S6ja = parcelRequire("3S6ja");
const $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $68910ca9bc088568$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5NtHI.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            role: 'presentation',
            children: children
        })
    });
};
var $68910ca9bc088568$export$2e2bcd8739ae039 = $68910ca9bc088568$var$HoverCardControl;

});
parcelRegister("3S6ja", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $4672c7a0b9a7b840$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $fezTc = parcelRequire("fezTc");

var $44bDi = parcelRequire("44bDi");

var $ct5r8 = parcelRequire("ct5r8");
const $4672c7a0b9a7b840$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ct5r8.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: (0, $5NtHI.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ct5r8.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ct5r8.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext = (0, $4J0ad.default)()($4672c7a0b9a7b840$var$HoverCardWithErrorBoundary);
const $4672c7a0b9a7b840$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ct5r8", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $bcd82f075ee4a70e$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $bcd82f075ee4a70e$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $92xoS = parcelRequire("92xoS");

var $5NtHI = parcelRequire("5NtHI");

var $bde0S = parcelRequire("bde0S");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");

var $44bDi = parcelRequire("44bDi");

var $dNwAf = parcelRequire("dNwAf");

var $awu5s = parcelRequire("awu5s");

var $kj7DC = parcelRequire("kj7DC");
const $bcd82f075ee4a70e$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $bcd82f075ee4a70e$var$FADE_IN_DELAY = 500;
const $bcd82f075ee4a70e$var$FADE_OUT_DELAY = 300;
const $bcd82f075ee4a70e$var$RESOLVE_DELAY = 100;
const $bcd82f075ee4a70e$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $kj7DC.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $bcd82f075ee4a70e$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $bde0S.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $kj7DC.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $kj7DC.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $bcd82f075ee4a70e$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $bcd82f075ee4a70e$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $5NtHI.ActionName).PreviewAction || actionId === (0, $5NtHI.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id,
            source: $bcd82f075ee4a70e$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $awu5s.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER,
                ...(0, $92xoS.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                    className: $bcd82f075ee4a70e$var$HOVER_CARD_TRIGGER_WRAPPER
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $dNwAf.default)
    });
};

});
parcelRegister("dNwAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $540bc4e78d228f2e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $540bc4e78d228f2e$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $540bc4e78d228f2e$export$2e2bcd8739ae039 = $540bc4e78d228f2e$var$CustomPopupContainer;

});

parcelRegister("awu5s", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $28757f6aaca5ab4f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $28757f6aaca5ab4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $FoFt2 = parcelRequire("FoFt2");

var $7tQSx = parcelRequire("7tQSx");

var $liquj = parcelRequire("liquj");

var $kj7DC = parcelRequire("kj7DC");

var $gpl3i = parcelRequire("gpl3i");

var $2bxQs = parcelRequire("2bxQs");

var $8Oxy9 = parcelRequire("8Oxy9");

var $hG20o = parcelRequire("hG20o");

var $1klMO = parcelRequire("1klMO");

var $jwqmr = parcelRequire("jwqmr");
const $28757f6aaca5ab4f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $28757f6aaca5ab4f$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $7tQSx.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $03JM4.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $gpl3i.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5NtHI.SmartLinkSize).Large,
        position: (0, $5NtHI.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $kj7DC.flexibleUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5NtHI.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1klMO.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwqmr.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Oxy9.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG20o.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bxQs.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $28757f6aaca5ab4f$export$2e2bcd8739ae039 = $28757f6aaca5ab4f$var$HoverCardContent;

});
parcelRegister("kj7DC", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $0426ea3ec103c831$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $0426ea3ec103c831$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $0426ea3ec103c831$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $0426ea3ec103c831$export$e7cae8c75d768024);

var $IW7jS = parcelRequire("IW7jS");

var $5NtHI = parcelRequire("5NtHI");
const $0426ea3ec103c831$export$8245b0eaabf3440c = (0, $IW7jS.layers).modal();
const $0426ea3ec103c831$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    zIndex: $0426ea3ec103c831$export$8245b0eaabf3440c + 1
};
const $0426ea3ec103c831$export$a0a37c997fbcd678 = 24;
const $0426ea3ec103c831$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("gpl3i", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $76d8fd2bfb093db5$export$8548546c0aa631e6);

var $dpM2S = parcelRequire("dpM2S");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");
const $76d8fd2bfb093db5$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $dpM2S.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5NtHI.ElementName).AuthorGroup,
            (0, $5NtHI.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).SubscriberCount,
                    (0, $5NtHI.ElementName).State
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).SourceBranch,
                    (0, $5NtHI.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5NtHI.ElementName).LatestCommit,
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1UXt3.extractOwnedBy)(data) ? (0, $5NtHI.ElementName).OwnedByGroup : (0, $5NtHI.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5NtHI.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5NtHI.ElementName).AssignedToGroup,
                        (0, $5NtHI.ElementName).State,
                        (0, $5NtHI.ElementName).StoryPoints,
                        (0, $5NtHI.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ],
                secondary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).AttachmentCount,
                    (0, $5NtHI.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix = [
    (0, $5NtHI.ElementName).AssignedToGroup,
    (0, $5NtHI.ElementName).OwnedByGroup,
    (0, $5NtHI.ElementName).AuthorGroup
];
const $76d8fd2bfb093db5$var$toElementItem = (name)=>{
    const showNamePrefix = $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $76d8fd2bfb093db5$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5NtHI.ElementName)).map($76d8fd2bfb093db5$var$toElementItem);
};
const $76d8fd2bfb093db5$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $76d8fd2bfb093db5$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $76d8fd2bfb093db5$var$toElementItems(metadata.subtitle),
        primary: $76d8fd2bfb093db5$var$toElementItems(primary),
        secondary: $76d8fd2bfb093db5$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("dpM2S", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $f106af885ce6cc9e$export$2e9ae379995d99e3);
const $f106af885ce6cc9e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});

parcelRegister("1UXt3", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $72576417d80bd61c$export$fb0960a89fb9c17b);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $72576417d80bd61c$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $72576417d80bd61c$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $72576417d80bd61c$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $72576417d80bd61c$export$bb52c21c67a309ca);
$parcel$export(module.exports, "extractVoteCount", () => $72576417d80bd61c$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $72576417d80bd61c$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $72576417d80bd61c$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $72576417d80bd61c$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $72576417d80bd61c$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $72576417d80bd61c$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $72576417d80bd61c$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $72576417d80bd61c$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $72576417d80bd61c$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $72576417d80bd61c$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $72576417d80bd61c$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $72576417d80bd61c$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $72576417d80bd61c$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $72576417d80bd61c$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $72576417d80bd61c$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $72576417d80bd61c$export$5c05c5b7ca37e36e);
$parcel$export(module.exports, "extractStoryPoints", () => $72576417d80bd61c$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $72576417d80bd61c$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $72576417d80bd61c$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $72576417d80bd61c$export$92037aea7f27bf7f);

var $3jSKi = parcelRequire("3jSKi");
var $fGP6b = parcelRequire("fGP6b");
var $aHgka = parcelRequire("aHgka");
var $3a3fF = parcelRequire("3a3fF");
var $hdxEk = parcelRequire("hdxEk");
const $72576417d80bd61c$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $72576417d80bd61c$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $72576417d80bd61c$export$b68822b76d5d51d5 = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:commentCount');
const $72576417d80bd61c$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $72576417d80bd61c$export$b68822b76d5d51d5(response?.data);
};
const $72576417d80bd61c$export$4356c594f5c138d6 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $72576417d80bd61c$export$ac56bd7a37249b48 = (data)=>$72576417d80bd61c$var$extractValue(data, 'endTime');
const $72576417d80bd61c$export$e57334ce4738e29d = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:viewCount');
const $72576417d80bd61c$export$44130aa92252501 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:reactCount');
const $72576417d80bd61c$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $72576417d80bd61c$export$44130aa92252501(response?.data);
};
const $72576417d80bd61c$export$c8bef3d5e550a3a = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:voteCount');
const $72576417d80bd61c$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $3a3fF.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$5546969a505305 = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $72576417d80bd61c$export$69b10d653f96288b = (data)=>{
    const persons = (0, $aHgka.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $hdxEk.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$43e54589935a1ff = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:programmingLanguage');
const $72576417d80bd61c$export$949ac6a8325b3fdb = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeSource']);
const $72576417d80bd61c$export$8bd03a7beb5badf1 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:subscriberCount');
const $72576417d80bd61c$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $72576417d80bd61c$export$65362ff78a97fd8 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:attachmentCount');
const $72576417d80bd61c$export$29b0ac5d2f9890cf = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeDestination']);
const $72576417d80bd61c$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $72576417d80bd61c$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $72576417d80bd61c$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $72576417d80bd61c$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $72576417d80bd61c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $72576417d80bd61c$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $72576417d80bd61c$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $72576417d80bd61c$export$cc4028b2878d0675 = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $72576417d80bd61c$export$b592ddecae70b61d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'dateSent');
};
const $72576417d80bd61c$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    return response?.data && $72576417d80bd61c$export$b592ddecae70b61d(response?.data);
};
const $72576417d80bd61c$export$bdcea84d1550eb9d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:storyPoints');
};
const $72576417d80bd61c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $72576417d80bd61c$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $72576417d80bd61c$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("fGP6b", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $5046cec7bbb70f2b$export$38a0979ebf273662);

var $9JeZK = parcelRequire("9JeZK");
const $5046cec7bbb70f2b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9JeZK.extractPersonFromJsonLd)(assignedTo);
};

});
parcelRegister("9JeZK", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $a634170ae128bef4$export$c471ae5fddcf1392);

var $4moW4 = parcelRequire("4moW4");
const $a634170ae128bef4$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $4moW4.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});
parcelRegister("4moW4", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $74d023e64fe83956$export$67f3d92c824fd850);

var $jo2Je = parcelRequire("jo2Je");
const $74d023e64fe83956$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});



parcelRegister("aHgka", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $537f0d3ea3fbcfb9$export$a66235cba0c9d11a);

var $9JeZK = parcelRequire("9JeZK");
const $537f0d3ea3fbcfb9$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("3a3fF", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $acd7880777d9e468$export$19ee667f3f7a6ec3);

var $9JeZK = parcelRequire("9JeZK");
const $acd7880777d9e468$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("hdxEk", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0);

var $9JeZK = parcelRequire("9JeZK");
const $9b8725aa10ec9f20$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
};

});



parcelRegister("2bxQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cef1c4bd3f25f5fc$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $gEJiH = parcelRequire("gEJiH");

var $awu5s = parcelRequire("awu5s");
const $cef1c4bd3f25f5fc$var$NEW_CARD_WIDTH_REM = 25;
const $cef1c4bd3f25f5fc$var$HoverCardContainerStyle = null;
const $cef1c4bd3f25f5fc$var$popupContainerStyles = null;
const $cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $gEJiH.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1e6u",
            (0, $awu5s.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gEJiH.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $cef1c4bd3f25f5fc$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $cef1c4bd3f25f5fc$export$2e2bcd8739ae039 = $cef1c4bd3f25f5fc$var$ContentContainer;

});
parcelRegister("gEJiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac4bb0b0e3771c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");

var $ic0QK = parcelRequire("ic0QK");

var $aIqUw = parcelRequire("aIqUw");
const $6ac4bb0b0e3771c8$var$contentStyles = null;
const $6ac4bb0b0e3771c8$var$contentStylesPrismVisible = null;
const $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $6ac4bb0b0e3771c8$var$popupContainerStyles = null;
const $6ac4bb0b0e3771c8$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ic0QK.default), {
        palette: (0, $aIqUw.AI_BORDER_PALETTE)[colorMode] ?? (0, $aIqUw.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rkopd34 _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $6ac4bb0b0e3771c8$export$2e2bcd8739ae039 = $6ac4bb0b0e3771c8$var$AIPrism;

});
parcelRegister("ic0QK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c556e491b590659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4gixb = parcelRequire("4gixb");
const $1c556e491b590659$var$borderContainerStyles = null;
const $1c556e491b590659$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1c556e491b590659$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1c556e491b590659$export$2e2bcd8739ae039 = $1c556e491b590659$var$AIGlowingBorder;

});
parcelRegister("4gixb", function(module, exports) {

$parcel$export(module.exports, "default", () => $915978962937a033$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $915978962937a033$var$namespaceUUID = 0;
const $915978962937a033$var$svgStyles = null;
const $915978962937a033$var$blurredStyles = null;
const $915978962937a033$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $915978962937a033$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $915978962937a033$var$namespaceUUID;
        $915978962937a033$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $915978962937a033$export$2e2bcd8739ae039 = $915978962937a033$var$AnimatedSvgContainer;

});


parcelRegister("aIqUw", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $668726bbe5390a04$export$23b7b83c7063ccfe);
const $668726bbe5390a04$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $668726bbe5390a04$export$23b7b83c7063ccfe = {
    dark: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue800,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal500,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue600,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal300,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("8Oxy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec0240a00cb7a69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $8Rjtc = parcelRequire("8Rjtc");
const $7ec0240a00cb7a69$var$titleBlockStyles = null;
const $7ec0240a00cb7a69$var$mainTextStyles = null;
const $7ec0240a00cb7a69$var$connectButtonStyles = null;
const $7ec0240a00cb7a69$var$basePreviewStyles = null;
const $7ec0240a00cb7a69$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $4Qxcv.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7r0tl.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13lipd34 _qrwqpd34 _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7ec0240a00cb7a69$export$2e2bcd8739ae039 = $7ec0240a00cb7a69$var$HoverCardForbiddenView;

});
parcelRegister("hy9OT", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkTitle", () => $27694d81d2f2dfcb$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $27694d81d2f2dfcb$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $27694d81d2f2dfcb$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $27694d81d2f2dfcb$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $27694d81d2f2dfcb$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $27694d81d2f2dfcb$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $27694d81d2f2dfcb$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $27694d81d2f2dfcb$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $27694d81d2f2dfcb$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $27694d81d2f2dfcb$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $27694d81d2f2dfcb$export$96ed4c1b14ac210a);

var $9R3Jd = parcelRequire("9R3Jd");
var $1IwHM = parcelRequire("1IwHM");
var $9T6dQ = parcelRequire("9T6dQ");
var $3seWH = parcelRequire("3seWH");
var $aHgka = parcelRequire("aHgka");
var $hdxEk = parcelRequire("hdxEk");
var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");

var $6OR2o = parcelRequire("6OR2o");

var $3jSKi = parcelRequire("3jSKi");
const $27694d81d2f2dfcb$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.displayName;
    return (0, $8T839.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $27694d81d2f2dfcb$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.url;
    return (0, $3seWH.extractLink)(response?.data);
};
const $27694d81d2f2dfcb$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.ari || (0, $3jSKi.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $9R3Jd.extractAri)(data);
};
const $27694d81d2f2dfcb$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $3jSKi.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $6OR2o.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $27694d81d2f2dfcb$export$ff753ed519e96e9e = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return response?.data && (0, $9Thyx.extractProvider)(response?.data);
};
const $27694d81d2f2dfcb$export$7a685df468cbf38f = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdAt;
    return response?.data && (0, $1IwHM.extractDateCreated)(response.data);
};
const $27694d81d2f2dfcb$export$75047940e157fd1f = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $9T6dQ.extractDateUpdated)(response.data);
};
const $27694d81d2f2dfcb$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $aHgka.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $27694d81d2f2dfcb$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $aHgka.extractPersonCreatedBy)(response.data);
};
const $27694d81d2f2dfcb$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $hdxEk.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $27694d81d2f2dfcb$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};

});
parcelRegister("1IwHM", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $9bce2094467d007a$export$e1226a5e0bbbf862);
const $9bce2094467d007a$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("9T6dQ", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7);
const $ab4b85685fa6a4de$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("9Thyx", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $af479a3c34473181$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $af479a3c34473181$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $af479a3c34473181$export$38df542ff03a4183);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");

var $lgMTT = parcelRequire("lgMTT");


var $4moW4 = parcelRequire("4moW4");
var $jo2Je = parcelRequire("jo2Je");
const $af479a3c34473181$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $af479a3c34473181$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $af479a3c34473181$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $af479a3c34473181$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
        else if (id === (0, $9f5235d88a87be7c$export$f654d825189934a7)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
            appearance: "brand",
            size: "xxsmall"
        });
    }
    if (icon) return (0, $4moW4.extractUrlFromIconJsonLd)(icon);
};
const $af479a3c34473181$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};
const $af479a3c34473181$export$38df542ff03a4183 = (id)=>{
    return id === (0, $9f5235d88a87be7c$export$cee224b5de4d6d66);
};

});
const $9f5235d88a87be7c$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $9f5235d88a87be7c$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $9f5235d88a87be7c$export$84a73a0383f58180 = 'JiraTask';
const $9f5235d88a87be7c$export$c6c83963a9378a67 = 'JiraSubTask';
const $9f5235d88a87be7c$export$58af3c426c111a6d = 'JiraStory';
const $9f5235d88a87be7c$export$ac9898a63417219e = 'JiraBug';
const $9f5235d88a87be7c$export$54db5e3fb12e39cd = 'JiraEpic';
const $9f5235d88a87be7c$export$2f54a5a217202c85 = 'JiraIncident';
const $9f5235d88a87be7c$export$d097371052bfc411 = 'JiraServiceRequest';
const $9f5235d88a87be7c$export$efd9452ad16c6676 = 'JiraChange';
const $9f5235d88a87be7c$export$2e7e70abb5d81f67 = 'JiraProblem';
const $9f5235d88a87be7c$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("8T839", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $8cab052601305f86$export$b05803156e5015b6);

var $inXgt = parcelRequire("inXgt");

var $dpM2S = parcelRequire("dpM2S");
const $8cab052601305f86$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $inXgt.extractContext)(jsonLd);
    const type = (0, $dpM2S.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("inXgt", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $1424377282a92e98$export$efdbd45f3e77a161);

var $dpM2S = parcelRequire("dpM2S");

var $4moW4 = parcelRequire("4moW4");
const $1424377282a92e98$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $4moW4.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $dpM2S.extractType)(context)
            };
        }
    }
};

});


parcelRegister("6OR2o", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115);

var $dToaf = parcelRequire("dToaf");

var $jo2Je = parcelRequire("jo2Je");
const $b7d97bd8e95d8e87$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $dToaf.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $jo2Je.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("dToaf", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $74d23019aa5430ff$export$3e8ad908070b68b2);
const $74d23019aa5430ff$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});



parcelRegister("7r0tl", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $acbd55282a01ac89$export$846c1540a86749e6);

var $19nmp = parcelRequire("19nmp");

var $b43DQ = parcelRequire("b43DQ");

var $5OkN2 = parcelRequire("5OkN2");

var $4Qxcv = parcelRequire("4Qxcv");
const $acbd55282a01ac89$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $4Qxcv.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $19nmp.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $19nmp.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $5OkN2.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $19nmp.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $19nmp.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("5OkN2", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $1cf8e394dba29dd6$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");
const $1cf8e394dba29dd6$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $19nmp.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("4Qxcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $37283c298b2f6d8f$export$2e2bcd8739ae039);
const $37283c298b2f6d8f$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $37283c298b2f6d8f$export$2e2bcd8739ae039 = $37283c298b2f6d8f$var$extractHostname;

});



parcelRegister("hG20o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d163d2cd5927fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $19G04 = parcelRequire("19G04");

var $4cjOx = parcelRequire("4cjOx");
var $eMgzj = parcelRequire("eMgzj");
var $2qnEp = parcelRequire("2qnEp");
var $gKsxm = parcelRequire("gKsxm");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $gpl3i = parcelRequire("gpl3i");

var $33eto = parcelRequire("33eto");
const $f7d163d2cd5927fd$var$hiddenSnippetStyles = null;
const $f7d163d2cd5927fd$var$titleBlockStyles = null;
const $f7d163d2cd5927fd$var$snippetBlockCss = null;
const $f7d163d2cd5927fd$var$actionBlockCss = null;
const $f7d163d2cd5927fd$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $gpl3i.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $33eto.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5NtHI.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qnEp.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cjOx.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eMgzj.default), {})
        ]
    });
};
var $f7d163d2cd5927fd$export$2e2bcd8739ae039 = $f7d163d2cd5927fd$var$HoverCardResolvedView;

});
parcelRegister("33eto", function(module, exports) {

$parcel$export(module.exports, "default", () => $114e5090f71be87e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $71sLJ = parcelRequire("71sLJ");

var $8Rjtc = parcelRequire("8Rjtc");
const $114e5090f71be87e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: "var(--ds-space-100, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $71sLJ.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $114e5090f71be87e$export$2e2bcd8739ae039 = $114e5090f71be87e$var$ImagePreview;

});
parcelRegister("71sLJ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $5db4479b590c898b$export$a79836076066b8b6);

var $3jSKi = parcelRequire("3jSKi");
var $GcYFq = parcelRequire("GcYFq");

var $5NtHI = parcelRequire("5NtHI");
const $5db4479b590c898b$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $GcYFq.extractImage)(data);
    return url ? {
        type: (0, $5NtHI.MediaType).Image,
        url: url
    } : undefined;
};
var $5db4479b590c898b$export$2e2bcd8739ae039 = $5db4479b590c898b$var$extractPreview;
const $5db4479b590c898b$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $5NtHI.MediaType).Image,
            url: url
        } : undefined;
    }
    return $5db4479b590c898b$var$extractPreview(response.data);
};

});
parcelRegister("GcYFq", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $d2101dc0ce9c996b$export$4c753a1297cb9805);

var $jo2Je = parcelRequire("jo2Je");
const $d2101dc0ce9c996b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("1klMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $208dcc57b264b5f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $65mpR = parcelRequire("65mpR");

var $d6nZP = parcelRequire("d6nZP");

var $kj7DC = parcelRequire("kj7DC");
const $208dcc57b264b5f9$var$loadingViewContainer = null;
const $208dcc57b264b5f9$var$skeletonContainer = null;
const $208dcc57b264b5f9$var$titleStyle = null;
const $208dcc57b264b5f9$var$titleBlockStyles = null;
const $208dcc57b264b5f9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $kj7DC.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $208dcc57b264b5f9$export$2e2bcd8739ae039 = $208dcc57b264b5f9$var$HoverCardLoadingView;

});

parcelRegister("jwqmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a30e9762e9a1caf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $jPfaa = parcelRequire("jPfaa");
const $a30e9762e9a1caf4$var$connectButtonStyles = null;
const $a30e9762e9a1caf4$var$titleBlockStyles = null;
const $a30e9762e9a1caf4$var$mainTextStyles = null;
const $a30e9762e9a1caf4$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $bde0S.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5NtHI.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $a30e9762e9a1caf4$export$2e2bcd8739ae039 = $a30e9762e9a1caf4$var$HoverCardUnauthorisedView;

});
parcelRegister("5z6NJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b17ec2d366022be$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4b17ec2d366022be$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).learn_more_about_connecting_account_appify : (0, $19nmp.messages).learn_more_about_connecting_account : (0, $19nmp.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_appify : (0, $19nmp.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $eGOwo.fg)('product-terminology-refresh') ? (0, $19nmp.messages).connect_unauthorised_account_description_no_provider_appify : (0, $19nmp.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                href: isProductIntegrationSupported ? (0, $5NtHI.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5NtHI.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4b17ec2d366022be$export$2e2bcd8739ae039 = $4b17ec2d366022be$var$UnauthorisedViewContent;

});






parcelRegister("59hpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $059fbcc0253de40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e3qu2 = parcelRequire("e3qu2");
const $059fbcc0253de40e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $059fbcc0253de40e$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $059fbcc0253de40e$export$2e2bcd8739ae039 = $059fbcc0253de40e$var$LayeredLink;

});


parcelRegister("025st", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $78d5204a1babb283$export$e68aec76e359e401);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $4ho8r = parcelRequire("4ho8r");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $19nmp = parcelRequire("19nmp");

var $FoFt2 = parcelRequire("FoFt2");

var $gA511 = parcelRequire("gA511");
const $78d5204a1babb283$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return (0, $4ho8r.default)(params);
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $8z78z.extractErrorIcon)(response, status),
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
                provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5NtHI.InternalActionName).UnresolvedAction]: $78d5204a1babb283$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                }
            };
    }
};
const $78d5204a1babb283$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $78d5204a1babb283$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hy9OT.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const access = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $78d5204a1babb283$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $19nmp.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $FoFt2.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $19nmp.messages).connect_link_account_card_name,
                onClick: (0, $FoFt2.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $19nmp.messages).cannot_find_link
            };
    }
};

});
parcelRegister("4ho8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4044cb6e4b021061$export$2e2bcd8739ae039);

var $3a3fF = parcelRequire("3a3fF");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $3SqDE = parcelRequire("3SqDE");

var $2YDTG = parcelRequire("2YDTG");

var $jIa7q = parcelRequire("jIa7q");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $2LW3F = parcelRequire("2LW3F");

var $96cCi = parcelRequire("96cCi");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $krByh = parcelRequire("krByh");

var $1UXt3 = parcelRequire("1UXt3");
const $4044cb6e4b021061$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    return {
        actions: (0, $2YDTG.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        appliedToComponentsCount: (0, $1UXt3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1UXt3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1UXt3.extractAttachmentCount)(data),
        authorGroup: (0, $hy9OT.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $3a3fF.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $jIa7q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1UXt3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $1UXt3.extractViewCount)(data),
        reactCount: (0, $1UXt3.extractSmartLinkReactCount)(response),
        voteCount: (0, $1UXt3.extractVoteCount)(data),
        checklistProgress: (0, $1UXt3.extractChecklistProgress)(data),
        createdBy: (0, $hy9OT.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1UXt3.extractOwnedBy)(data),
        assignedTo: (0, $1UXt3.extractAssignedTo)(data),
        createdOn: (0, $hy9OT.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1UXt3.extractDueOn)(data),
        latestCommit: (0, $krByh.extractLatestCommit)(data),
        linkIcon: (0, $8z78z.extractSmartLinkIcon)(response),
        linkTitle: (0, $13x9L.default)(status, props.url, response, onClick),
        location: (0, $1UXt3.extractLocation)(data),
        modifiedBy: (0, $hy9OT.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $hy9OT.extractSmartLinkModifiedOn)(response),
        preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
        priority: (0, $2LW3F.default)(data),
        provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1UXt3.extractProgrammingLanguage)(data),
        readTime: (0, $1UXt3.extractReadTime)(data),
        sentOn: (0, $1UXt3.extractSmartLinkSentOn)(response),
        snippet: (0, $3SqDE.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1UXt3.extractSourceBranch)(data),
        state: (0, $96cCi.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel),
        subscriberCount: (0, $1UXt3.extractSubscriberCount)(data),
        subTasksProgress: (0, $1UXt3.extractSubTasksProgress)(data),
        storyPoints: (0, $1UXt3.extractStoryPoints)(data),
        targetBranch: (0, $1UXt3.extractTargetBranch)(data),
        ...(0, $eGOwo.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1UXt3.extractUserAttributes)(data)
        },
        ...(0, $eGOwo.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1UXt3.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $hy9OT.extractSmartLinkAri)(response),
        type: (0, $dpM2S.extractType)(data),
        ...(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $1UXt3.extractMetaObjectId)(meta),
                resourceType: (0, $1UXt3.extractMetaResourceType)(meta),
                tenantId: (0, $1UXt3.extractMetaTenantId)(meta)
            }
        }
    };
};
var $4044cb6e4b021061$export$2e2bcd8739ae039 = $4044cb6e4b021061$var$extractFlexibleUiContext;

});
parcelRegister("3SqDE", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7e45c18a3795a6b$export$8c6b9b49f358840);

var $3jSKi = parcelRequire("3jSKi");
const $f7e45c18a3795a6b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7e45c18a3795a6b$export$8c6b9b49f358840 = (response)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.description;
    return response?.data && $f7e45c18a3795a6b$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("2YDTG", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $df0887593ff7101f$export$abe8d0ca1daa1755);

var $5NtHI = parcelRequire("5NtHI");

var $4DFm3 = parcelRequire("4DFm3");

var $glHkX = parcelRequire("glHkX");

var $71e7e = parcelRequire("71e7e");

var $9ZYEf = parcelRequire("9ZYEf");

var $7xgpC = parcelRequire("7xgpC");

var $l3lcT = parcelRequire("l3lcT");

var $iJBt4 = parcelRequire("iJBt4");
const $df0887593ff7101f$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $5NtHI.ActionName).CopyLinkAction]: (0, $71e7e.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).DownloadAction]: (0, $9ZYEf.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).FollowAction]: (0, $7xgpC.default)(response, actionOptions, id),
        [(0, $5NtHI.ActionName).PreviewAction]: (0, $l3lcT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        [(0, $5NtHI.ActionName).AutomationAction]: (0, $glHkX.extractAutomationAction)(response),
        [(0, $5NtHI.InternalActionName).AISummaryAction]: (0, $4DFm3.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5NtHI.InternalActionName).ViewRelatedLinksAction]: (0, $iJBt4.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4DFm3", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $3a123960ee44ec9b$export$e7f7a50a8b8932df);

var $2fsAU = parcelRequire("2fsAU");

var $7tQSx = parcelRequire("7tQSx");

var $18DG7 = parcelRequire("18DG7");
const $3a123960ee44ec9b$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).AISummaryAction, actionOptions) || !(0, $7tQSx.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2fsAU", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $2264131ee11f6725$export$2487b058456cca75);
const $2264131ee11f6725$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});

parcelRegister("18DG7", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $ff948bb743384c72$export$f40b7e0b762b928b);
var $ff948bb743384c72$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});


parcelRegister("glHkX", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $26db5af86415f15e$export$f913cc6abf3ec084);

var $5NtHI = parcelRequire("5NtHI");
const $26db5af86415f15e$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5NtHI.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("71e7e", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $c1fb7cacddedb674$export$31ddd5c40039ce53);

var $kGroK = parcelRequire("kGroK");
const $c1fb7cacddedb674$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $kGroK.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("kGroK", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $944dc4c637fc31a2$export$5ec86886067a062d);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");
const $944dc4c637fc31a2$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5NtHI.ActionName).CopyLinkAction,
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("9ZYEf", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $8b4fa13cd6f1b67f$export$f6c386869a352b1f);

var $ccFJO = parcelRequire("ccFJO");
const $8b4fa13cd6f1b67f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ccFJO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ccFJO", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $0aeada01337c8e80$export$ea97cd34c2ca86de);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $0aeada01337c8e80$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $hy9OT.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $FoFt2.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5NtHI.ActionName).DownloadAction,
            definitionId: (0, $03JM4.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $03JM4.getExtensionKey)(response),
            id: id,
            resourceType: (0, $03JM4.getResourceType)(response)
        };
    }
};

});
parcelRegister("blyJR", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $a3fe6b36e98c43c2$export$8f031784a3a03b23);
const $a3fe6b36e98c43c2$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});



parcelRegister("7xgpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7e2884a85971c9$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");
var $dpM2S = parcelRequire("dpM2S");

var $5CgrK = parcelRequire("5CgrK");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $bT52P = parcelRequire("bT52P");
const $2d7e2884a85971c9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    const type = (0, $dpM2S.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $5CgrK.SmartLinkActionType).FollowEntityAction || actionName === (0, $5CgrK.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $3seWH.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $5CgrK.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $2d7e2884a85971c9$export$2e2bcd8739ae039 = $2d7e2884a85971c9$var$extractFollowAction;

});
parcelRegister("bT52P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb63d54723b1798$export$2e2bcd8739ae039);
const $bfb63d54723b1798$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $bfb63d54723b1798$export$2e2bcd8739ae039 = $bfb63d54723b1798$var$extractServerAction;

});


parcelRegister("l3lcT", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $be48c7ee2c64cc3a$export$9f0d9100b079448);

var $5O37S = parcelRequire("5O37S");
const $be48c7ee2c64cc3a$export$9f0d9100b079448 = (param)=>{
    const result = (0, $5O37S.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};

});
parcelRegister("5O37S", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $5a058ee1f9e9b538$export$caf83f49e52ac0bb);

var $6OR2o = parcelRequire("6OR2o");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $aNEbu = parcelRequire("aNEbu");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");

var $8z78z = parcelRequire("8z78z");

var $ccFJO = parcelRequire("ccFJO");

var $el1MG = parcelRequire("el1MG");
const $5a058ee1f9e9b538$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $cbSL1.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).PreviewAction, actionOptions)) return;
    const src = (0, $6OR2o.extractPreview)(data, 'web')?.src;
    if (src) {
        const extensionKey = (0, $03JM4.getExtensionKey)(response);
        return {
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) openPreviewPanel({
                        ari: ari,
                        url: url,
                        name: name,
                        iconUrl: undefined
                    });
                    else await (0, $aNEbu.openEmbedModal)({
                        fireEvent: fireEvent,
                        extensionKey: extensionKey,
                        id: id,
                        invokeDownloadAction: (0, $ccFJO.extractInvokeDownloadAction)(param),
                        invokeViewAction: (0, $el1MG.extractInvokeViewAction)(param, true),
                        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
                        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
                        linkIcon: (0, $8z78z.extractLinkIcon)(response),
                        providerName: (0, $hy9OT.extractSmartLinkProvider)(response)?.text,
                        onClose: onClose,
                        origin: origin,
                        src: (0, $hy9OT.extractSmartLinkEmbed)(response)?.src,
                        title: (0, $hy9OT.extractSmartLinkTitle)(response),
                        url: url,
                        size: (0, $eGOwo.fg)('platform_linking_enable_card_preview_action_size') ? actionOptions?.previewAction?.size : undefined
                    });
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5NtHI.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            },
            hasPreviewPanel: hasPreviewPanel
        };
    }
};

});
parcelRegister("aNEbu", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $2e72cab05fd02eba$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
const $2e72cab05fd02eba$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2e72cab05fd02eba$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("3nRTS"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $2e72cab05fd02eba$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("3nRTS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("16B8C")
]).then(()=>parcelRequire('lJ0K6'));

});


parcelRegister("b5GVx", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $d6879f4d400478b0$export$38d755f52cdf4acb);

var $3DgO9 = parcelRequire("3DgO9");
const $d6879f4d400478b0$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $3DgO9.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("3DgO9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $a195a16b307c9ed2$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $a195a16b307c9ed2$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $a195a16b307c9ed2$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $a195a16b307c9ed2$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $a195a16b307c9ed2$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $a195a16b307c9ed2$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $a195a16b307c9ed2$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $a195a16b307c9ed2$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $a195a16b307c9ed2$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $a195a16b307c9ed2$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $a195a16b307c9ed2$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $a195a16b307c9ed2$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $a195a16b307c9ed2$export$fe44ce30fd8d131b);
const $a195a16b307c9ed2$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $a195a16b307c9ed2$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $a195a16b307c9ed2$export$84a73a0383f58180 = 'JiraTask';
const $a195a16b307c9ed2$export$c6c83963a9378a67 = 'JiraSubTask';
const $a195a16b307c9ed2$export$58af3c426c111a6d = 'JiraStory';
const $a195a16b307c9ed2$export$ac9898a63417219e = 'JiraBug';
const $a195a16b307c9ed2$export$54db5e3fb12e39cd = 'JiraEpic';
const $a195a16b307c9ed2$export$2f54a5a217202c85 = 'JiraIncident';
const $a195a16b307c9ed2$export$d097371052bfc411 = 'JiraServiceRequest';
const $a195a16b307c9ed2$export$efd9452ad16c6676 = 'JiraChange';
const $a195a16b307c9ed2$export$2e7e70abb5d81f67 = 'JiraProblem';
const $a195a16b307c9ed2$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $a195a16b307c9ed2$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider'
];

});


parcelRegister("1jpb6", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $ec58a694a8b15740$export$4f3ffbb500daac5a);
const $ec58a694a8b15740$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("8z78z", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $908dbe215fe49acc$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $908dbe215fe49acc$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $908dbe215fe49acc$export$35040aed9264b11c);

var $3jSKi = parcelRequire("3jSKi");

var $5NtHI = parcelRequire("5NtHI");

var $1zbM5 = parcelRequire("1zbM5");

var $lBR2D = parcelRequire("lBR2D");

var $kYbGg = parcelRequire("kYbGg");
const $908dbe215fe49acc$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $1zbM5.default)(data, renderers);
    return {
        ...(0, $lBR2D.default)(data),
        render: render
    };
};
const $908dbe215fe49acc$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kYbGg.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5NtHI.IconType).Forbidden
            };
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5NtHI.IconType).Error
            };
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5NtHI.IconType).Default
            };
    }
};
const $908dbe215fe49acc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityIcon)(response);
    return $908dbe215fe49acc$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("1zbM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $006269c1cd396984$export$2e2bcd8739ae039);
const $006269c1cd396984$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $006269c1cd396984$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $006269c1cd396984$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $006269c1cd396984$export$2e2bcd8739ae039 = $006269c1cd396984$var$extractIconRenderer;

});

parcelRegister("lBR2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $294e9df0fd90b4dc$export$2e2bcd8739ae039);

var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");

var $l5kRv = parcelRequire("l5kRv");

var $3DgO9 = parcelRequire("3DgO9");

var $3LiRd = parcelRequire("3LiRd");

var $dyU3L = parcelRequire("dyU3L");

var $imtUu = parcelRequire("imtUu");

var $kYbGg = parcelRequire("kYbGg");

var $6LWK3 = parcelRequire("6LWK3");
const $294e9df0fd90b4dc$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $l5kRv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $294e9df0fd90b4dc$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0] : type;
};
const $294e9df0fd90b4dc$var$isJiraProvider = (provider)=>provider === (0, $3DgO9.JIRA_GENERATOR_ID);
function $294e9df0fd90b4dc$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dyU3L.default)(fileFormat);
    const documentTypeIcon = $294e9df0fd90b4dc$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $3LiRd.default)(type, label, providerId);
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $294e9df0fd90b4dc$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $5NtHI.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5NtHI.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5NtHI.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5NtHI.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5NtHI.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5NtHI.IconType).Task,
                label: taskLabel
            };
            if ($294e9df0fd90b4dc$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $294e9df0fd90b4dc$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $imtUu.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $294e9df0fd90b4dc$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $8T839.extractTitle)(data);
    const type = $294e9df0fd90b4dc$var$extractType(data);
    const urlIcon = (0, $6LWK3.default)(data.icon, label);
    const providerIcon = (0, $kYbGg.default)(data);
    return $294e9df0fd90b4dc$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $294e9df0fd90b4dc$export$2e2bcd8739ae039 = $294e9df0fd90b4dc$var$extractJsonldDataIcon;

});
parcelRegister("abbo9", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $2e5b1fff8f67610f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $2e5b1fff8f67610f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("aDkpj", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4);
const $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("l5kRv", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $30b3c63f6ca4244d$export$ed3fd59180514d27);

var $4moW4 = parcelRequire("4moW4");
const $30b3c63f6ca4244d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $4moW4.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("3LiRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b1006362800173$export$2e2bcd8739ae039);

var $9Thyx = parcelRequire("9Thyx");

var $5NtHI = parcelRequire("5NtHI");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $75b1006362800173$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5NtHI.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $9Thyx.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5NtHI.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $5NtHI.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5NtHI.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $75b1006362800173$export$2e2bcd8739ae039 = $75b1006362800173$var$extractDocumentTypeIcon;

});

parcelRegister("imtUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebe1a8cda0f126bd$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $ebe1a8cda0f126bd$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5NtHI.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5NtHI.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5NtHI.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5NtHI.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5NtHI.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5NtHI.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5NtHI.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5NtHI.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label
            };
    }
};
var $ebe1a8cda0f126bd$export$2e2bcd8739ae039 = $ebe1a8cda0f126bd$var$extractJiraTaskIcon;

});

parcelRegister("kYbGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bccbab21d09288f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $1bccbab21d09288f$export$5def189f04eea025);

var $3jSKi = parcelRequire("3jSKi");
var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $3DgO9 = parcelRequire("3DgO9");

var $6LWK3 = parcelRequire("6LWK3");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $1bccbab21d09288f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $8T839.extractTitle)(data);
    if (provider === (0, $3DgO9.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $3DgO9.JIRA_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $6LWK3.default)(icon, label);
};
var $1bccbab21d09288f$export$2e2bcd8739ae039 = $1bccbab21d09288f$var$extractProviderIcon;
const $1bccbab21d09288f$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $3DgO9.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $3DgO9.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $3jSKi.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $1bccbab21d09288f$var$extractProviderIcon(response.data);
};

});
parcelRegister("6LWK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $500a210ebb43c155$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $500a210ebb43c155$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $500a210ebb43c155$export$2e2bcd8739ae039 = $500a210ebb43c155$var$extractUrlIcon;

});




parcelRegister("el1MG", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $8933c20370529de6$export$88c5813cfbbe4e4c);

var $3seWH = parcelRequire("3seWH");

var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $8933c20370529de6$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $3seWH.extractLink)(data);
    const viewActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $FoFt2.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});



parcelRegister("iJBt4", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $30a13f343fd23d01$export$debae7424a0231b9);

var $hy9OT = parcelRequire("hy9OT");
const $30a13f343fd23d01$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $hy9OT.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("jIa7q", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $afd980b8f5408674$export$216e4f6aa7c169b8);

var $8pdx9 = parcelRequire("8pdx9");
var $9JeZK = parcelRequire("9JeZK");
const $afd980b8f5408674$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $8pdx9.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("8pdx9", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $491ba0064e87a086$export$6281d080d62a0719);

var $9JeZK = parcelRequire("9JeZK");
const $491ba0064e87a086$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9JeZK.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9JeZK.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("13x9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77867f4004a4594$export$2e2bcd8739ae039);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
const $f77867f4004a4594$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $hy9OT.extractSmartLinkUrl)(response);
    const url = status === (0, $5NtHI.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const text = status === (0, $5NtHI.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $f77867f4004a4594$export$2e2bcd8739ae039 = $f77867f4004a4594$var$extractLinkTitle;

});

parcelRegister("2LW3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $46aad986c1287f3b$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");

var $5NtHI = parcelRequire("5NtHI");
const $46aad986c1287f3b$var$priorityMapper = {
    blocker: (0, $5NtHI.IconType).PriorityBlocker,
    critical: (0, $5NtHI.IconType).PriorityCritical,
    high: (0, $5NtHI.IconType).PriorityHigh,
    highest: (0, $5NtHI.IconType).PriorityHighest,
    low: (0, $5NtHI.IconType).PriorityLow,
    lowest: (0, $5NtHI.IconType).PriorityLowest,
    major: (0, $5NtHI.IconType).PriorityMajor,
    medium: (0, $5NtHI.IconType).PriorityMedium,
    minor: (0, $5NtHI.IconType).PriorityMinor,
    trivial: (0, $5NtHI.IconType).PriorityTrivial,
    undefined: (0, $5NtHI.IconType).PriorityUndefined
};
const $46aad986c1287f3b$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $46aad986c1287f3b$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $4moW4.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $46aad986c1287f3b$export$2e2bcd8739ae039 = $46aad986c1287f3b$var$extractPriority;

});

parcelRegister("96cCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $599db3951a68070c$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $5O37S = parcelRequire("5O37S");

var $bpSSH = parcelRequire("bpSSH");

var $bT52P = parcelRequire("bT52P");
const $599db3951a68070c$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $599db3951a68070c$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $3seWH.extractLink)(data);
    const invokePreviewAction = response ? (0, $5O37S.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $599db3951a68070c$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $bpSSH.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $599db3951a68070c$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel);
    return {
        ...lozenge,
        action: action
    };
};
var $599db3951a68070c$export$2e2bcd8739ae039 = $599db3951a68070c$var$extractState;

});
parcelRegister("bpSSH", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $c2b51845c5984a0b$export$e5da155556a77bca);

var $dpM2S = parcelRequire("dpM2S");

var $8haf8 = parcelRequire("8haf8");

var $1Kr9e = parcelRequire("1Kr9e");

var $7ncIg = parcelRequire("7ncIg");

var $l5kRv = parcelRequire("l5kRv");
const $c2b51845c5984a0b$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $dpM2S.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $1Kr9e.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $7ncIg.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $c2b51845c5984a0b$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $8haf8.extractState)(jsonLd);
    }
};
const $c2b51845c5984a0b$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $l5kRv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("8haf8", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $76dc1be10470e17b$export$5e4074cbce6574c7);

var $9tSQF = parcelRequire("9tSQF");
// Maps accent color short names to their corresponding background and text colors
const $76dc1be10470e17b$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $76dc1be10470e17b$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9tSQF.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9tSQF.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $76dc1be10470e17b$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9tSQF", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $ae66787404c6b4b4$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $ae66787404c6b4b4$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $ae66787404c6b4b4$export$772610da74ddbc07);
const $ae66787404c6b4b4$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $ae66787404c6b4b4$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $ae66787404c6b4b4$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $ae66787404c6b4b4$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $ae66787404c6b4b4$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("1Kr9e", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $00d711d353e3bb83$export$962a8da34cf78a4f);

var $9tSQF = parcelRequire("9tSQF");
const $00d711d353e3bb83$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($00d711d353e3bb83$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $00d711d353e3bb83$var$extractTagItem(tag);
    }
};
const $00d711d353e3bb83$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9tSQF.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("7ncIg", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $7aa28bf1d699e3b1$export$7698df1946deda72);
const $7aa28bf1d699e3b1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("krByh", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $ce13437708ceefb0$export$f222392162cff0d8);
const $ce13437708ceefb0$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("g7toL", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $e227bf38409b8990$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $e227bf38409b8990$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $e227bf38409b8990$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $e227bf38409b8990$export$9671929f11bd4ad8);

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");

var $03JM4 = parcelRequire("03JM4");
const $e227bf38409b8990$var$baseTopMetadata = [
    {
        name: (0, $5NtHI.ElementName).ModifiedOn
    },
    {
        name: (0, $5NtHI.ElementName).AttachmentCount
    },
    {
        name: (0, $5NtHI.ElementName).SubscriberCount
    },
    {
        name: (0, $5NtHI.ElementName).VoteCount
    },
    {
        name: (0, $5NtHI.ElementName).DueOn
    },
    {
        name: (0, $5NtHI.ElementName).ReadTime
    }
];
const $e227bf38409b8990$var$baseBottomMetaData = [
    {
        name: (0, $5NtHI.ElementName).ReactCount
    },
    {
        name: (0, $5NtHI.ElementName).CommentCount
    },
    {
        name: (0, $5NtHI.ElementName).ViewCount
    },
    {
        name: (0, $5NtHI.ElementName).Priority
    },
    {
        name: (0, $5NtHI.ElementName).SubTasksProgress
    },
    {
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }
];
const $e227bf38409b8990$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5NtHI.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5NtHI.ElementName).AuthorGroup
        },
        {
            name: (0, $5NtHI.ElementName).CreatedBy
        },
        ...$e227bf38409b8990$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $e227bf38409b8990$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5NtHI.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
            if ((0, $eGOwo.fg)('passionfruit_ask_smart_links_enabled_afm')) return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
            else return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AuthorGroup
                },
                {
                    name: (0, $5NtHI.ElementName).CreatedBy
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5NtHI.ElementName).AssignedTo
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5NtHI.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5NtHI.ElementName).Priority
                    },
                    {
                        name: (0, $5NtHI.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).ReactCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).UserAttributes
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $e227bf38409b8990$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $e227bf38409b8990$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5NtHI.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5NtHI.SmartLinkSize).Large
};
const $e227bf38409b8990$export$9671929f11bd4ad8 = {
    placement: (0, $5NtHI.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("lc1jH", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $c6261e336be0cca4$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c6261e336be0cca4$var$flexibleBlockCardStyle = null;
const $c6261e336be0cca4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g96pd34 _1qo3h6cr"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("1uPx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e11d03c412e160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $gA511 = parcelRequire("gA511");

var $38cBa = parcelRequire("38cBa");

var $fPNY3 = parcelRequire("fPNY3");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $c5e11d03c412e160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e11d03c412e160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
    const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $4Qxcv.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $7r0tl.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $fPNY3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $fPNY3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $c5e11d03c412e160$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($c5e11d03c412e160$var$ForbiddenView);

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});

parcelRegister("idDkX", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $d5f398015422946e$export$d14c2a6dee946f52);

var $19nmp = parcelRequire("19nmp");
const $d5f398015422946e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $19nmp.messages)) return (0, $19nmp.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("fPNY3", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $f4b684ab7f00a73c$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $f4b684ab7f00a73c$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eB1dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa49cd5b8f02fcca$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $aa49cd5b8f02fcca$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $aa49cd5b8f02fcca$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $19nmp.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $19nmp.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $aa49cd5b8f02fcca$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($aa49cd5b8f02fcca$var$NotFoundView);

});

parcelRegister("8jMdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d529b5b9d214a4cd$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $19G04 = parcelRequire("19G04");

var $lAF2k = parcelRequire("lAF2k");
var $gKsxm = parcelRequire("gKsxm");
var $8Rjtc = parcelRequire("8Rjtc");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");

var $lc1jH = parcelRequire("lc1jH");
const $d529b5b9d214a4cd$var$titleBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d529b5b9d214a4cd$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []);
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $g7toL.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $g7toL.FlexibleCardUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $5NtHI.ElementName).Location
                    }
                ],
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAF2k.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d529b5b9d214a4cd$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($d529b5b9d214a4cd$var$ResolvedView);

});

parcelRegister("4fOPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1855e7f6748dd65c$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $6Xgel = parcelRequire("6Xgel");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $1855e7f6748dd65c$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1855e7f6748dd65c$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $6Xgel.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syaz1fxt _19pku2gc"
            ]),
            children: content
        })
    });
};
var $1855e7f6748dd65c$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($1855e7f6748dd65c$var$UnauthorisedView);

});
parcelRegister("6Xgel", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $3bad804239ca8758$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $3bad804239ca8758$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5NtHI.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("9uyEx", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $05d9abb62f80e331$export$6789d7ecdc77631b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $7r0tl = parcelRequire("7r0tl");

var $7AKPz = parcelRequire("7AKPz");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $9gzoR = parcelRequire("9gzoR");

var $gA511 = parcelRequire("gA511");

var $4UV7R = parcelRequire("4UV7R");

var $8jMdw = parcelRequire("8jMdw");

var $eIvWj = parcelRequire("eIvWj");

var $hFl6W = parcelRequire("hFl6W");

var $i53U1 = parcelRequire("i53U1");

var $5RX8x = parcelRequire("5RX8x");

var $h9g6U = parcelRequire("h9g6U");

var $iUsXM = parcelRequire("iUsXM");
const $05d9abb62f80e331$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    }) : children;
};
const $05d9abb62f80e331$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7AKPz", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $bddb5ab530f782ff$export$d6cf81ca6e68bcc3);

var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $9xgNQ = parcelRequire("9xgNQ");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");
const $bddb5ab530f782ff$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response) || '',
        title: (0, $hy9OT.extractSmartLinkTitle)(response),
        context: (0, $9xgNQ.extractSmartLinkContext)(response),
        preview: (0, $hy9OT.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("9xgNQ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkContext", () => $81938710ecd918a9$export$6ec4b6b24dec9156);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $4moW4 = parcelRequire("4moW4");

var $gA511 = parcelRequire("gA511");

var $abbo9 = parcelRequire("abbo9");

var $7r0tl = parcelRequire("7r0tl");
function $81938710ecd918a9$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $9Thyx.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $81938710ecd918a9$export$6ec4b6b24dec9156(response) {
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return $81938710ecd918a9$export$8dcb07487061d3c1(response?.data || (0, $gA511.getEmptyJsonLd)());
}

});


parcelRegister("aRZRK", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $56b7d71381ad586c$export$68e1703c529dc7e0);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $gA511 = parcelRequire("gA511");

var $k4P1T = parcelRequire("k4P1T");

var $bpSSH = parcelRequire("bpSSH");

var $7BqfG = parcelRequire("7BqfG");

var $gxXx6 = parcelRequire("gxXx6");

var $3DgO9 = parcelRequire("3DgO9");
const $56b7d71381ad586c$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $3DgO9.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $3DgO9.JIRA_GENERATOR_ID)) return (0, $k4P1T.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $k4P1T.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $56b7d71381ad586c$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $56b7d71381ad586c$var$extractInlineIcon(response?.data || (0, $gA511.getEmptyJsonLd)(), showLabel);
};
const $56b7d71381ad586c$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response),
        title: (0, $hy9OT.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $56b7d71381ad586c$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $bpSSH.extractLozenge)(jsonLd),
        titleTextColor: (0, $7BqfG.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $gxXx6.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $dpM2S.extractType)(jsonLd)
    };
};

});
parcelRegister("k4P1T", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $0a1959a1b48f0e49$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $liS9g = parcelRequire("liS9g");

var $gSqCA = parcelRequire("gSqCA");

var $6wUJL = parcelRequire("6wUJL");

var $es92x = parcelRequire("es92x");

var $cOjgE = parcelRequire("cOjgE");

var $lG2jM = parcelRequire("lG2jM");

var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");
var $4moW4 = parcelRequire("4moW4");

var $FoFt2 = parcelRequire("FoFt2");

var $l5kRv = parcelRequire("l5kRv");

var $ip2tE = parcelRequire("ip2tE");

var $l8s0O = parcelRequire("l8s0O");

var $1yraT = parcelRequire("1yraT");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");
const $0a1959a1b48f0e49$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $8T839.extractTitle)(jsonLd),
        provider: (0, $9Thyx.extractProvider)(jsonLd),
        fileFormat: (0, $ip2tE.extractFileFormat)(jsonLd),
        taskType: (0, $l5kRv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        return $0a1959a1b48f0e49$var$extractIconByType(highestPriorityType, opts);
    } else return $0a1959a1b48f0e49$var$extractIconByType(type, opts);
};
function $0a1959a1b48f0e49$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wUJL.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $es92x.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liS9g.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gSqCA.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1yraT.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a1959a1b48f0e49$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $FoFt2.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a1959a1b48f0e49$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $l8s0O.extractIconFromDocument)(type, opts);
        default:
            return $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("liS9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fba6d3a5fd6972fb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57895ef0b52fd8c4c74cfb41dd495e36>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $awZZu = parcelRequire("awZZu");

var $cBTRt = parcelRequire("cBTRt");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fba6d3a5fd6972fb$var$Branch16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
            label: label,
            testId: testId
        })
    });
};
$fba6d3a5fd6972fb$var$Branch16Icon.displayName = 'Branch16Icon';
var $fba6d3a5fd6972fb$export$2e2bcd8739ae039 = $fba6d3a5fd6972fb$var$Branch16Icon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("cBTRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3462a9699ad70391$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::625730c3236ac1826cad47b39a1764d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $3462a9699ad70391$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$3462a9699ad70391$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3462a9699ad70391$export$2e2bcd8739ae039 = $3462a9699ad70391$var$Branch16Icon;

});


parcelRegister("gSqCA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $978ab5b169d02f01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e82b283fed135d161349bed7f64fbf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $8lO5P = parcelRequire("8lO5P");

var $j8Au4 = parcelRequire("j8Au4");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $978ab5b169d02f01$var$Code16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
            label: label,
            testId: testId
        })
    });
};
$978ab5b169d02f01$var$Code16Icon.displayName = 'Code16Icon';
var $978ab5b169d02f01$export$2e2bcd8739ae039 = $978ab5b169d02f01$var$Code16Icon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1091d7b3916e42e9c126eb0a1ee5598a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});

parcelRegister("j8Au4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6502744a03af16$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d003ccf13a9ed7b17e1f0e343e52054d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7a6502744a03af16$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7a6502744a03af16$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a6502744a03af16$export$2e2bcd8739ae039 = $7a6502744a03af16$var$Code16Icon;

});


parcelRegister("6wUJL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c727218f2343b747$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f2c30ba9921a6754c4914a2815ab1ac6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $7XCnf = parcelRequire("7XCnf");

var $1OiKX = parcelRequire("1OiKX");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c727218f2343b747$var$Commit16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
            label: label,
            testId: testId
        })
    });
};
$c727218f2343b747$var$Commit16Icon.displayName = 'Commit16Icon';
var $c727218f2343b747$export$2e2bcd8739ae039 = $c727218f2343b747$var$Commit16Icon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab489d2a38e8a0acc1962f05ff04e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("1OiKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd5ceb37ab40bc73$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14dd3b796d1706ede7eb831d28deffaa>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $bd5ceb37ab40bc73$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$bd5ceb37ab40bc73$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd5ceb37ab40bc73$export$2e2bcd8739ae039 = $bd5ceb37ab40bc73$var$Commit16Icon;

});


parcelRegister("es92x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $44741c921c28f10f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2fa1578bca00f96f8398b8ab3053f83>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $MUJuW = parcelRequire("MUJuW");

var $3xtgM = parcelRequire("3xtgM");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $44741c921c28f10f$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
            label: label,
            testId: testId
        })
    });
};
$44741c921c28f10f$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $44741c921c28f10f$export$2e2bcd8739ae039 = $44741c921c28f10f$var$PullRequest16Icon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("3xtgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $38a04956c9fd4802$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a228b6a8cc996f7aacfdd22dc7d2cc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $38a04956c9fd4802$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$38a04956c9fd4802$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$38a04956c9fd4802$export$2e2bcd8739ae039 = $38a04956c9fd4802$var$PullRequest16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e3cfaee41b098df8ae4032fe4210963>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $bwM92 = parcelRequire("bwM92");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("dSbyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c287ed46a4f0bca8d14d4f24a4bb3c80>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68ed51f9e1612abe38768085b9e3fc4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("ip2tE", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $733ec07b82674776$export$f2d65f02f6888b60);
const $733ec07b82674776$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("l8s0O", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $f67edadeb7739c7c$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kSre2 = parcelRequire("kSre2");

var $9Thyx = parcelRequire("9Thyx");

var $4Gz8O = parcelRequire("4Gz8O");

var $lQKQC = parcelRequire("lQKQC");

var $iOphm = parcelRequire("iOphm");

var $4VIPx = parcelRequire("4VIPx");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $FoFt2 = parcelRequire("FoFt2");

var $abbo9 = parcelRequire("abbo9");
const $f67edadeb7739c7c$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $f67edadeb7739c7c$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $f67edadeb7739c7c$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f67edadeb7739c7c$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $FoFt2.getIconForFileType)(opts.fileFormat);
};
const $f67edadeb7739c7c$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $f67edadeb7739c7c$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lQKQC.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VIPx.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kSre2))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $f67edadeb7739c7c$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $9Thyx.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iOphm.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a76a3f4404ba59acd822415adfff8b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        name: "FileIcon",
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.displayName = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("lQKQC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $457cf0e778e4e077$export$2e2bcd8739ae039);

var $5cEyJ = parcelRequire("5cEyJ");

var $1TONM = parcelRequire("1TONM");

var $amDP4 = parcelRequire("amDP4");

var $cPcks = parcelRequire("cPcks");
const $457cf0e778e4e077$var$ChartBarIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), 'purpleBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5cEyJ))), (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))));
$457cf0e778e4e077$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $457cf0e778e4e077$export$2e2bcd8739ae039 = $457cf0e778e4e077$var$ChartBarIconWithColor;

});
parcelRegister("5cEyJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c9d88f73aaa21a0$var$_react = $3c9d88f73aaa21a0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3c9d88f73aaa21a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c9d88f73aaa21a0$var$Presentation16Icon = (props)=>/*#__PURE__*/ $3c9d88f73aaa21a0$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c9d88f73aaa21a0$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $3c9d88f73aaa21a0$var$_default = module.exports.default = $3c9d88f73aaa21a0$var$Presentation16Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});


parcelRegister("iOphm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d1a6648d509434f8$export$2e2bcd8739ae039);

var $hLSBq = parcelRequire("hLSBq");

var $btZ6J = parcelRequire("btZ6J");

var $jvbqF = parcelRequire("jvbqF");

var $cPcks = parcelRequire("cPcks");
const $d1a6648d509434f8$var$FileIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), 'grayBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($hLSBq))), (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))));
$d1a6648d509434f8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d1a6648d509434f8$export$2e2bcd8739ae039 = $d1a6648d509434f8$var$FileIconWithColor;

});
parcelRegister("hLSBq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cf012e6694ca1348$var$_react = $cf012e6694ca1348$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $cf012e6694ca1348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf012e6694ca1348$var$Generic16Icon = (props)=>/*#__PURE__*/ $cf012e6694ca1348$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cf012e6694ca1348$var$Generic16Icon.displayName = 'Generic16Icon';
var $cf012e6694ca1348$var$_default = module.exports.default = $cf012e6694ca1348$var$Generic16Icon;

});

parcelRegister("btZ6J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85c1cdd5f70b300c$var$_react = $85c1cdd5f70b300c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $85c1cdd5f70b300c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85c1cdd5f70b300c$var$Generic24Icon = (props)=>/*#__PURE__*/ $85c1cdd5f70b300c$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85c1cdd5f70b300c$var$Generic24Icon.displayName = 'Generic24Icon';
var $85c1cdd5f70b300c$var$_default = module.exports.default = $85c1cdd5f70b300c$var$Generic24Icon;

});


parcelRegister("4VIPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $261b25b77463fadb$export$2e2bcd8739ae039);

var $avN5P = parcelRequire("avN5P");

var $i9oSq = parcelRequire("i9oSq");

var $hJIkn = parcelRequire("hJIkn");

var $cPcks = parcelRequire("cPcks");
const $261b25b77463fadb$var$ListBulletedIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), 'greenBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($avN5P))), (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))));
$261b25b77463fadb$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $261b25b77463fadb$export$2e2bcd8739ae039 = $261b25b77463fadb$var$ListBulletedIconWithColor;

});
parcelRegister("avN5P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a72e175f7c6772a$var$_react = $7a72e175f7c6772a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7a72e175f7c6772a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72e175f7c6772a$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $7a72e175f7c6772a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a72e175f7c6772a$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $7a72e175f7c6772a$var$_default = module.exports.default = $7a72e175f7c6772a$var$Spreadsheet16Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});



parcelRegister("1yraT", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4555066ff891e98a$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i3nvV = parcelRequire("i3nvV");

var $59W6U = parcelRequire("59W6U");

var $4VGMo = parcelRequire("4VGMo");

var $h6Xfo = parcelRequire("h6Xfo");

var $8WXuv = parcelRequire("8WXuv");

var $erbJ6 = parcelRequire("erbJ6");

var $iaeCZ = parcelRequire("iaeCZ");

var $dV8me = parcelRequire("dV8me");

var $cOjgE = parcelRequire("cOjgE");

var $3DgO9 = parcelRequire("3DgO9");
const $4555066ff891e98a$var$TaskIcon = (0, $cOjgE.default);
const $4555066ff891e98a$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($4555066ff891e98a$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $3DgO9.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $3DgO9.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $3DgO9.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dV8me.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $3DgO9.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $3DgO9.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $3DgO9.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VGMo.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $3DgO9.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6Xfo.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $3DgO9.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $3DgO9.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59W6U.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $3DgO9.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erbJ6.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $3DgO9.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b3eace3db32e909d8e4c2d548565af4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $9UdpB = parcelRequire("9UdpB");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("ePICl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6b2aaa54dc8ca05673d473e302061ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("59W6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b85119f148eef897$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::505d8909c8998f8492f66eab6e38980b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $4aDUk = parcelRequire("4aDUk");

var $bqSXM = parcelRequire("bqSXM");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b85119f148eef897$var$Changes16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
            label: label,
            testId: testId
        })
    });
};
$b85119f148eef897$var$Changes16Icon.displayName = 'Changes16Icon';
var $b85119f148eef897$export$2e2bcd8739ae039 = $b85119f148eef897$var$Changes16Icon;

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c248cb8ff46f92a14313d2de4318df80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("bqSXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5517f3f5f4a6b147$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43edfd1c3679c7345c2a442459999c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $5517f3f5f4a6b147$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$5517f3f5f4a6b147$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5517f3f5f4a6b147$export$2e2bcd8739ae039 = $5517f3f5f4a6b147$var$Changes16Icon;

});


parcelRegister("4VGMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $adbcbb4e84b923ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef3c8ed5e57f17047733a8020ce784d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gtN4u = parcelRequire("gtN4u");

var $3zPlh = parcelRequire("3zPlh");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $adbcbb4e84b923ab$var$Epic16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
            label: label,
            testId: testId
        })
    });
};
$adbcbb4e84b923ab$var$Epic16Icon.displayName = 'Epic16Icon';
var $adbcbb4e84b923ab$export$2e2bcd8739ae039 = $adbcbb4e84b923ab$var$Epic16Icon;

});
parcelRegister("gtN4u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bff56b51666b12d4$var$_react = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bff56b51666b12d4$var$_baseNew = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bff56b51666b12d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bff56b51666b12d4$var$EpicIcon = (props)=>/*#__PURE__*/ $bff56b51666b12d4$var$_react.default.createElement($bff56b51666b12d4$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$bff56b51666b12d4$var$EpicIcon.displayName = 'EpicIcon';
var $bff56b51666b12d4$var$_default = module.exports.default = $bff56b51666b12d4$var$EpicIcon;

});

parcelRegister("3zPlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e901c858f1e000$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::142d10bfd50eb509af7927d7baa82685>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $07e901c858f1e000$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$07e901c858f1e000$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07e901c858f1e000$export$2e2bcd8739ae039 = $07e901c858f1e000$var$Epic16Icon;

});


parcelRegister("h6Xfo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $10b82fbbd3c25549$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ede68a79193f0a8a70fa374ba104253c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $ljmsu = parcelRequire("ljmsu");

var $ewxpd = parcelRequire("ewxpd");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $10b82fbbd3c25549$var$Incident16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
            label: label,
            testId: testId
        })
    });
};
$10b82fbbd3c25549$var$Incident16Icon.displayName = 'Incident16Icon';
var $10b82fbbd3c25549$export$2e2bcd8739ae039 = $10b82fbbd3c25549$var$Incident16Icon;

});
parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f39860ce7f984391648fef01b18ffad3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("ewxpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $629cf392ad3aaa3f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b29b882c898f601323f622b31bfeccd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $629cf392ad3aaa3f$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$629cf392ad3aaa3f$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$629cf392ad3aaa3f$export$2e2bcd8739ae039 = $629cf392ad3aaa3f$var$Incident16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f51ecb48642a229c7b6d1a69d64d867>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $c59mr = parcelRequire("c59mr");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("28xc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe2288302fb4009a8dfaa99b181ad17d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("erbJ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a57d8898cb2acd54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45711362ad054d9d0de581c03f164950>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gNXvC = parcelRequire("gNXvC");

var $kFcVs = parcelRequire("kFcVs");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a57d8898cb2acd54$var$Problem16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
            label: label,
            testId: testId
        })
    });
};
$a57d8898cb2acd54$var$Problem16Icon.displayName = 'Problem16Icon';
var $a57d8898cb2acd54$export$2e2bcd8739ae039 = $a57d8898cb2acd54$var$Problem16Icon;

});
parcelRegister("gNXvC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3166f2fe0f47ea82d95571c4b7ab84>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf622d2894843f$var$_react = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c3bf622d2894843f$var$_baseNew = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c3bf622d2894843f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf622d2894843f$var$ProblemIcon = (props)=>/*#__PURE__*/ $c3bf622d2894843f$var$_react.default.createElement($c3bf622d2894843f$var$_baseNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$c3bf622d2894843f$var$ProblemIcon.displayName = 'ProblemIcon';
var $c3bf622d2894843f$var$_default = module.exports.default = $c3bf622d2894843f$var$ProblemIcon;

});

parcelRegister("kFcVs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a016a8b27712b47b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22fd64be1230cdfa956ed09821e612ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a016a8b27712b47b$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$a016a8b27712b47b$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a016a8b27712b47b$export$2e2bcd8739ae039 = $a016a8b27712b47b$var$Problem16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::544b9f71dc9f7001702597ba0216e61f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $hVZow = parcelRequire("hVZow");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("ayExB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::888e49ac8aee51ec38f43bede32963e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("dV8me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $462b7112313631bd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4f42caad88ed71da33903f9c7053102>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $d67Vm = parcelRequire("d67Vm");

var $kqL94 = parcelRequire("kqL94");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $462b7112313631bd$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
            label: label,
            testId: testId
        })
    });
};
$462b7112313631bd$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $462b7112313631bd$export$2e2bcd8739ae039 = $462b7112313631bd$var$Subtask16Icon;

});
parcelRegister("d67Vm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c160a9f26591f77220765c2e9d99939c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9891fb7b92d506c5$var$_react = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9891fb7b92d506c5$var$_baseNew = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9891fb7b92d506c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9891fb7b92d506c5$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9891fb7b92d506c5$var$_react.default.createElement($9891fb7b92d506c5$var$_baseNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$9891fb7b92d506c5$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9891fb7b92d506c5$var$_default = module.exports.default = $9891fb7b92d506c5$var$SubtasksIcon;

});

parcelRegister("kqL94", function(module, exports) {

$parcel$export(module.exports, "default", () => $602f9b1db5d82f1d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d77b8a2607635762876eadf6c30777eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $602f9b1db5d82f1d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$602f9b1db5d82f1d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$602f9b1db5d82f1d$export$2e2bcd8739ae039 = $602f9b1db5d82f1d$var$Subtask16Icon;

});




parcelRegister("7BqfG", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $33546c004f5f4832$export$a2afc198e9dada1);


var $aDkpj = parcelRequire("aDkpj");
const $33546c004f5f4832$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $7bb4c1736002a04a$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("gxXx6", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $c5f184c1c3b70b36$export$58d9bc37318dfb32);
const $c5f184c1c3b70b36$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c5f184c1c3b70b36$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c5f184c1c3b70b36$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("eIvWj", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $f516ef55418d7e1c$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $3S6ja = parcelRequire("3S6ja");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
class $f516ef55418d7e1c$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    type: type,
                    hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("k6uZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c0fa079b82f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");
const $7e6c0fa079b82f37$var$wrapperStyles = null;
const $7e6c0fa079b82f37$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
var $7e6c0fa079b82f37$export$2e2bcd8739ae039 = $7e6c0fa079b82f37$var$InlineLozenge;

});

parcelRegister("3KRDe", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $5d532ff440b5b275$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $5d532ff440b5b275$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $av9Of = parcelRequire("av9Of");

var $8IeH1 = parcelRequire("8IeH1");

var $cbSL1 = parcelRequire("cbSL1");

var $FoFt2 = parcelRequire("FoFt2");

var $3aPI4 = parcelRequire("3aPI4");
const $5d532ff440b5b275$var$iconWrapperStyle = null;
const $5d532ff440b5b275$var$iconImageStyle = null;
const $5d532ff440b5b275$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkogqwt",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko1twn"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $5d532ff440b5b275$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $FoFt2.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton) {
            if (hasImageErrored) return errored;
            return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                onError: ()=>setHasImageErrored(true),
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aPI4.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $5d532ff440b5b275$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $5d532ff440b5b275$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($5d532ff440b5b275$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $5d532ff440b5b275$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $5d532ff440b5b275$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $5d532ff440b5b275$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $5d532ff440b5b275$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("3aPI4", function(module, exports) {

$parcel$export(module.exports, "Shimmer", () => $4025455d45ae9834$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $klP06 = parcelRequire("klP06");
const $4025455d45ae9834$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4025455d45ae9834$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klP06.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("klP06", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $e1fe181bedc556ac$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $e1fe181bedc556ac$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $e1fe181bedc556ac$var$placeholderShimmer = null;
const $e1fe181bedc556ac$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $7bb4c1736002a04a$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $e1fe181bedc556ac$var$spanSkeletonStyles = null;
const $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $e1fe181bedc556ac$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $e1fe181bedc556ac$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $e1fe181bedc556ac$export$2e2bcd8739ae039 = $e1fe181bedc556ac$export$8f31e4c4a37b8e9c;

});




parcelRegister("hFl6W", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $35d1688af0eea2fa$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");


var $19nmp = parcelRequire("19nmp");

var $05blM = parcelRequire("05blM");
const $35d1688af0eea2fa$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $35d1688af0eea2fa$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $05blM.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $35d1688af0eea2fa$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).could_not_load_link
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("05blM", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $5e19ca37647e9fa5$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5e19ca37647e9fa5$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$7b360cd785b6c366, {
        ...props
    });
const $5e19ca37647e9fa5$var$sharedBaseFrameStyles = null;
const $5e19ca37647e9fa5$var$sharedFrameStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightTrueStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightFalseStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameStyles = null;
const $5e19ca37647e9fa5$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkosqtm _1h6d1can _1dqonqa1 _189eyh40" : "_2rko1lya _1h6d3acm _1dqonqa1 _189eyh40",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $5e19ca37647e9fa5$var$compactFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsTrueStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsFalseStyles = null;
const $5e19ca37647e9fa5$var$compactFrameAlignStyles = null;
const $5e19ca37647e9fa5$var$compactFrameStyles = null;
const $5e19ca37647e9fa5$var$compactFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rkosqtm _1h6d1can _1dqonqa1 _189eyh40",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("i53U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cede8882a7ef616$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $hVxRW = parcelRequire("hVxRW");
const $1cede8882a7ef616$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $idDkX.toMessage)((0, $19nmp.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hVxRW.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $1cede8882a7ef616$export$2e2bcd8739ae039 = $1cede8882a7ef616$var$ForbiddenView;

});
parcelRegister("l22Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0a8b05351117ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $av9Of = parcelRequire("av9Of");

var $2l8bu = parcelRequire("2l8bu");

var $gegRH = parcelRequire("gegRH");
const $fe0a8b05351117ab$var$containerStyles = null;
const $fe0a8b05351117ab$var$contentStyles = null;
const $fe0a8b05351117ab$var$descriptionStyles = null;
const $fe0a8b05351117ab$var$imageStyles = null;
const $fe0a8b05351117ab$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fe0a8b05351117ab$export$2e2bcd8739ae039 = $fe0a8b05351117ab$var$UnresolvedView;

});
parcelRegister("2l8bu", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $5f28b71e696600f5$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $e3qu2 = parcelRequire("e3qu2");

var $dDP8i = parcelRequire("dDP8i");

var $65oSX = parcelRequire("65oSX");
const $5f28b71e696600f5$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqzzgxb _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvzgxb _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19it1pvm _2rko1y44 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("65oSX", function(module, exports) {

$parcel$export(module.exports, "className", () => $11f8274f575811f3$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $11f8274f575811f3$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $11f8274f575811f3$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $11f8274f575811f3$export$2913c0c0b5623090 = 'media-card-frame';
const $11f8274f575811f3$export$8f5a73ba0d077b01 = 32;
const $11f8274f575811f3$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $11f8274f575811f3$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($11f8274f575811f3$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $11f8274f575811f3$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gegRH", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $28cc40acfaa5a547$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $cbSL1 = parcelRequire("cbSL1");

var $65oSX = parcelRequire("65oSX");
const $28cc40acfaa5a547$var$styles = {
    roundedImage: "_2rko1twn"
};
const $28cc40acfaa5a547$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $eJOHy.useCallback)(()=>{
        if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(true);
    }, []);
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65oSX.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && $28cc40acfaa5a547$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton && (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? {
            onError: handleError
        } : undefined
    });
    if ((0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("hVxRW", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $d57be4b9de9beae3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $d57be4b9de9beae3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5RX8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc831c55b9e606a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $KprKQ = parcelRequire("KprKQ");
const $9fc831c55b9e606a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $KprKQ.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $9fc831c55b9e606a$export$2e2bcd8739ae039 = $9fc831c55b9e606a$var$NotFoundView;

});
parcelRegister("KprKQ", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $8c23d6ed0b92caba$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $8c23d6ed0b92caba$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("h9g6U", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $367ff287c16eda7a$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $eGOwo = parcelRequire("eGOwo");

var $58yRG = parcelRequire("58yRG");

var $FoFt2 = parcelRequire("FoFt2");

var $2l8bu = parcelRequire("2l8bu");

var $e3qHE = parcelRequire("e3qHE");

var $gegRH = parcelRequire("gegRH");

var $diXta = parcelRequire("diXta");
const $367ff287c16eda7a$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $FoFt2.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton
    ]);
    if ((0, $eGOwo.fg)('ptc-enable-embed-team-smart-links')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $diXta.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e3qHE.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text
        })
    });
});

});
parcelRegister("e3qHE", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $32febd87e387ddae$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $FoFt2 = parcelRequire("FoFt2");

var $hprWR = parcelRequire("hprWR");

var $RCgNH = parcelRequire("RCgNH");
function $32febd87e387ddae$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $32febd87e387ddae$var$iframeStyles = null;
const $32febd87e387ddae$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rkosqtm _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("hprWR", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $0dab6c672ddaa5a8$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $0dab6c672ddaa5a8$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};

});

parcelRegister("RCgNH", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $069958df693c5c51$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $069958df693c5c51$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $069958df693c5c51$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $069958df693c5c51$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});


parcelRegister("diXta", function(module, exports) {

$parcel$export(module.exports, "useEmbedResolvePostMessageListener", () => $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa);

var $eJOHy = parcelRequire("eJOHy");

var $kbv8x = parcelRequire("kbv8x");
const $b1c14f9c00d049d7$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $kbv8x.default)();
    (0, $eJOHy.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve(url, true);
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};

});


parcelRegister("iUsXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5z6NJ = parcelRequire("5z6NJ");

var $l22Ft = parcelRequire("l22Ft");

var $5x724 = parcelRequire("5x724");
const $9a8ffe7d7e8e9c62$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5x724.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039 = $9a8ffe7d7e8e9c62$var$UnauthorizedView;

});
parcelRegister("5x724", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $f913a8b5e191dd5f$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $f913a8b5e191dd5f$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("6J1DL", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $71d51cdd37301ec2$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $cbSL1 = parcelRequire("cbSL1");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $gA511 = parcelRequire("gA511");

var $kj3Kk = parcelRequire("kj3Kk");

var $3sgI9 = parcelRequire("3sgI9");

var $6kw7n = parcelRequire("6kw7n");

var $eIvWj = parcelRequire("eIvWj");

var $4dnWW = parcelRequire("4dnWW");

var $kFkj1 = parcelRequire("kFkj1");
const $71d51cdd37301ec2$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    }) : children;
};
const $71d51cdd37301ec2$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5NtHI.SmartLinkStatus).Resolved ? (0, $aRZRK.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($71d51cdd37301ec2$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4dnWW.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: (0, $cbSL1.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFkj1.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hy9OT.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kw7n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3sgI9.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("3sgI9", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $f78d8ca0def2e8b6$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1NG86 = parcelRequire("1NG86");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $f78d8ca0def2e8b6$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $f78d8ca0def2e8b6$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon || $f78d8ca0def2e8b6$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("4Rp6r", function(module, exports) {

$parcel$export(module.exports, "ActionButton", () => $36fa193905cb5ef0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $46R8N = parcelRequire("46R8N");
const $36fa193905cb5ef0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $36fa193905cb5ef0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $36fa193905cb5ef0$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $36fa193905cb5ef0$var$styles.innerContainer,
                isDisabled ? $36fa193905cb5ef0$var$styles.disabled : $36fa193905cb5ef0$var$styles.enabled
            ]),
            children: children
        })
    });
});

});


parcelRegister("6kw7n", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $5783739fd5be2c19$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $5783739fd5be2c19$var$styles = {
    actionButtonLozengeStyle: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $5783739fd5be2c19$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $5783739fd5be2c19$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
            xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
                appearance: "moved",
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: renderForbiddenAccessMessage()
            })
        });
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $5783739fd5be2c19$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});


parcelRegister("4dnWW", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $7b3077a1d4f02d91$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");

var $8a4B6 = parcelRequire("8a4B6");
const $7b3077a1d4f02d91$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7b3077a1d4f02d91$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            xcss: $7b3077a1d4f02d91$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3KRDe.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8a4B6.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("8a4B6", function(module, exports) {

$parcel$export(module.exports, "RightIconPositionWrapper", () => $9116d903068768cf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9116d903068768cf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kFkj1", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $38c365e1bf03afe8$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $38c365e1bf03afe8$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small"
    });
};
const $38c365e1bf03afe8$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $38c365e1bf03afe8$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});




parcelRegister("8wC3Q", function(module, exports) {

$parcel$export(module.exports, "LazyLazilyRenderCard", () => $ef3b63961fc9f8a1$export$ff05cac3dc0bcc8d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hk4Ns = parcelRequire("hk4Ns");

var $1mLfK = parcelRequire("1mLfK");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
function $ef3b63961fc9f8a1$export$ff05cac3dc0bcc8d(props) {
    const { appearance: appearance, container: container, id: id } = props;
    const offset = Math.ceil(window.innerHeight / 4);
    (0, $eJOHy.useState)(()=>{
        // Start of experience when intersectionObserver is not supported.
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id);
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hk4Ns.default), {
        offset: offset,
        component: appearance === 'inline' ? 'span' : 'div',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "loader-wrapper",
        placeholder: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...props
        }),
        scrollContainer: container,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
            ...props
        })
    });
}

});
parcelRegister("hk4Ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c8067713fa41b6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fPMMi = parcelRequire("fPMMi");

var $33dyc = parcelRequire("33dyc");

var $b7Pst = parcelRequire("b7Pst");

var $ebmGF = parcelRequire("ebmGF");

var $f5YpG = parcelRequire("f5YpG");

var $lzei4 = parcelRequire("lzei4");

var $drbf6 = parcelRequire("drbf6");
function $c9c8067713fa41b6$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c9c8067713fa41b6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c9c8067713fa41b6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c9c8067713fa41b6$var$_typeof(obj);
}
function $c9c8067713fa41b6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c9c8067713fa41b6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c9c8067713fa41b6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c9c8067713fa41b6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c9c8067713fa41b6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c9c8067713fa41b6$var$_possibleConstructorReturn(self, call) {
    if (call && ($c9c8067713fa41b6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c9c8067713fa41b6$var$_assertThisInitialized(self);
}
function $c9c8067713fa41b6$var$_getPrototypeOf(o) {
    $c9c8067713fa41b6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c9c8067713fa41b6$var$_getPrototypeOf(o);
}
function $c9c8067713fa41b6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c9c8067713fa41b6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c9c8067713fa41b6$var$_setPrototypeOf(subClass, superClass);
}
function $c9c8067713fa41b6$var$_setPrototypeOf(o, p) {
    $c9c8067713fa41b6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c9c8067713fa41b6$var$_setPrototypeOf(o, p);
}
function $c9c8067713fa41b6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c9c8067713fa41b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    $c9c8067713fa41b6$var$_inherits(LazilyRender, _React$Component);
    function LazilyRender() {
        var _getPrototypeOf2;
        var _this;
        $c9c8067713fa41b6$var$_classCallCheck(this, LazilyRender);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c9c8067713fa41b6$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $c9c8067713fa41b6$var$_getPrototypeOf(LazilyRender)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "raf", void 0);
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "element", void 0);
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "container", void 0);
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "state", {
            hasBeenScrolledIntoView: false
        });
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "update", function() {
            cancelAnimationFrame(_this.raf);
            _this.raf = requestAnimationFrame(function() {
                var elementBounds = _this.getElementBounds();
                var viewportBounds = _this.getViewportBounds();
                var offsetBounds = _this.getOffsetBounds();
                if (!elementBounds || !viewportBounds) return;
                if ((0, $f5YpG.default)(elementBounds, viewportBounds, offsetBounds)) {
                    _this.stopListening(_this.container);
                    _this.setState({
                        hasBeenScrolledIntoView: true
                    }, function() {
                        var onRender = _this.props.onRender;
                        if (onRender) onRender();
                    });
                }
            });
        });
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "handleMount", function(element) {
            var scrollContainer = _this.props.scrollContainer;
            _this.element = element;
            _this.container = _this.getContainer(scrollContainer);
        });
        return _this;
    }
    $c9c8067713fa41b6$var$_createClass(LazilyRender, [
        {
            key: "getContainer",
            value: function getContainer(scrollContainer) {
                if (scrollContainer) return scrollContainer;
                else {
                    if (this.element) {
                        var container = (0, (/*@__PURE__*/$parcel$interopDefault($fPMMi)))(this.element);
                        if (container === document.scrollingElement || container === document.documentElement || !(0, $lzei4.default)() && container == document.body) return window;
                        else return container;
                    } else return undefined;
                }
            }
        },
        {
            key: "getViewportBounds",
            value: function getViewportBounds() {
                return (0, $33dyc.default)(this.container);
            }
        },
        {
            key: "getElementBounds",
            value: function getElementBounds() {
                return (0, $b7Pst.default)(this.element);
            }
        },
        {
            key: "getOffsetBounds",
            value: function getOffsetBounds() {
                var offset = this.props.offset;
                return (0, $ebmGF.default)(offset);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var prevContainer = prevProps.scrollContainer;
                var nextContainer = this.props.scrollContainer; // If a scroll container was defined before, do some cleanup
                // and bootstrap the next scroll container.
                if (prevContainer !== nextContainer) {
                    // If the previous container was already utilised, no cleanup
                    // is required - already done in LazilyRender.update().
                    if (!prevState.hasBeenScrolledIntoView) this.stopListening(prevContainer);
                     // Set a new listener if the scrollContainer is defined, and update 
                    // the container property accordingly. Note: this should only be done
                    // when the next container is different.
                    this.container = this.getContainer(nextContainer);
                    this.startListening(this.container); // Signal that the element has not been scrolled into view and 
                    // recompute its position. This will essentially 'reset' the node's
                    // current status back to a placeholder item if need be.
                    this.setState({
                        hasBeenScrolledIntoView: false
                    }, function() {
                        _this2.update();
                    });
                }
            }
        },
        {
            key: "startListening",
            value: function startListening(container) {
                if (container) container.addEventListener('scroll', this.update, (0, $drbf6.default));
                window.addEventListener('resize', this.update);
            }
        },
        {
            key: "stopListening",
            value: function stopListening(container) {
                if (container) container.removeEventListener('scroll', this.update, (0, $drbf6.default));
                window.removeEventListener('resize', this.update);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.update();
                this.startListening(this.container);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListening(this.container);
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var _this$props = this.props, placeholder = _this$props.placeholder, content = _this$props.content, children = _this$props.children;
                var hasBeenScrolledIntoView = this.state.hasBeenScrolledIntoView;
                if (!hasBeenScrolledIntoView && placeholder) return placeholder;
                if (hasBeenScrolledIntoView && content) return content;
                if (children) return children(hasBeenScrolledIntoView);
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, component = _this$props2.component;
                return $eJOHy.createElement(component || 'div', {
                    ref: this.handleMount,
                    className: className,
                    children: this.renderChildren()
                });
            }
        }
    ]);
    return LazilyRender;
}($eJOHy.Component);

});
parcelRegister("fPMMi", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, module.exports) module.exports = factory();
    else root.Scrollparent = factory();
})(module.exports, function() {
    var regex = /(auto|scroll)/;
    var parents = function(node, ps) {
        if (node.parentNode === null) return ps;
        return parents(node.parentNode, ps.concat([
            node
        ]));
    };
    var style = function(node, prop) {
        return getComputedStyle(node, null).getPropertyValue(prop);
    };
    var overflow = function(node) {
        return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
    };
    var scroll = function(node) {
        return regex.test(overflow(node));
    };
    var scrollParent = function(node) {
        if (!(node instanceof HTMLElement || node instanceof SVGElement)) return;
        var ps = parents(node.parentNode, []);
        for(var i = 0; i < ps.length; i += 1){
            if (scroll(ps[i])) return ps[i];
        }
        return document.scrollingElement || document.documentElement;
    };
    return scrollParent;
});

});

parcelRegister("33dyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $238c29c110dc849e$export$2e2bcd8739ae039);

var $b7Pst = parcelRequire("b7Pst");
function $238c29c110dc849e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $238c29c110dc849e$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $238c29c110dc849e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $238c29c110dc849e$export$2e2bcd8739ae039(container) {
    if (!container) return undefined;
    if (container === window) return {
        top: window.pageYOffset,
        left: window.pageXOffset,
        bottom: window.pageYOffset + window.innerHeight,
        right: window.pageXOffset + window.innerWidth
    };
    else {
        var bounds = (0, $b7Pst.default)(container);
        if (bounds) return $238c29c110dc849e$var$_objectSpread({}, bounds, {
            bottom: bounds.top + container.offsetHeight,
            right: bounds.left + container.offsetWidth
        });
        else return undefined;
    }
}

});
parcelRegister("b7Pst", function(module, exports) {

$parcel$export(module.exports, "default", () => $819843b102792787$export$2e2bcd8739ae039);
function $819843b102792787$export$2e2bcd8739ae039(element) {
    if (!element) return undefined;
    var rect = element.getBoundingClientRect();
    return {
        left: window.pageXOffset + rect.left,
        right: window.pageXOffset + rect.left + rect.width,
        top: window.pageYOffset + rect.top,
        bottom: window.pageYOffset + rect.top + rect.height
    };
}

});


parcelRegister("ebmGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a533b0f56bb7c661$export$2e2bcd8739ae039);
function $a533b0f56bb7c661$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a533b0f56bb7c661$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a533b0f56bb7c661$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a533b0f56bb7c661$var$_typeof(obj);
}
function $a533b0f56bb7c661$export$2e2bcd8739ae039(offset) {
    if (!offset) return undefined;
    var offsetTop;
    var offsetRight;
    var offsetBottom;
    var offsetLeft;
    if ($a533b0f56bb7c661$var$_typeof(offset) === 'object') {
        offsetTop = offset.top || 0;
        offsetRight = offset.right || 0;
        offsetBottom = offset.bottom || 0;
        offsetLeft = offset.left || 0;
    } else {
        offsetTop = offset || 0;
        offsetRight = offset || 0;
        offsetBottom = offset || 0;
        offsetLeft = offset || 0;
    }
    return {
        top: offsetTop,
        right: offsetRight,
        bottom: offsetBottom,
        left: offsetLeft
    };
}

});

parcelRegister("f5YpG", function(module, exports) {

$parcel$export(module.exports, "default", () => $afd62f7a4eb8aeb4$export$2e2bcd8739ae039);
function $afd62f7a4eb8aeb4$export$2e2bcd8739ae039(elementBounds, viewportBounds, offset) {
    var offsetTop = offset && offset.top || 0;
    var offsetRight = offset && offset.right || 0;
    var offsetBottom = offset && offset.bottom || 0;
    var offsetLeft = offset && offset.left || 0;
    return elementBounds.bottom + offsetBottom >= viewportBounds.top && elementBounds.top - offsetTop <= viewportBounds.bottom && elementBounds.right + offsetRight >= viewportBounds.left && elementBounds.left - offsetLeft <= viewportBounds.right;
}

});

parcelRegister("lzei4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb37f3a1ef8ce023$export$2e2bcd8739ae039);
var $fb37f3a1ef8ce023$export$2e2bcd8739ae039 = function() {
    return document.compatMode === "BackCompat";
};

});

parcelRegister("drbf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c86848687969eb2$export$2e2bcd8739ae039);
var $9c86848687969eb2$var$isPassiveListenerSupported = function isPassiveListenerSupported() {
    var supported = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supported = true;
            }
        });
        window.addEventListener('test', null, opts);
        window.removeEventListener('test', null, opts);
    } catch (e) {}
    return supported;
};
var $9c86848687969eb2$export$2e2bcd8739ae039 = $9c86848687969eb2$var$isPassiveListenerSupported() ? {
    passive: true
} : undefined;

});





//# sourceMappingURL=@atlaskit-internal_smartcard-urlcardcontent.8d4e3376.js.map
